import React, { useEffect, useState, useCallback, useMemo, useRef } from "react";
import Modal from 'react-modal'
import ModalContent from "../../common/Modal/ModalContent";
import close_modal from '../../assets/ic_close_wh.svg'
import { Button } from "../../common/Button/Button";
import ReactTable from "react-table";
import "react-table/react-table.css";
import ReactMultiSelectCheckboxes from 'react-multiselect-checkboxes';
import moment from "moment";
import Spinner from "../../common/Spinner/Spinner";
import Select from "react-select";
import find from "lodash/find";
import { Info } from "react-feather";
import { ControlledInput } from "../../common/Input/Input";
import ESPNotesLogDropdown from "../../containers/EServicePartnerServiceRequests/ESPNotesLogDropdown";
import ReactDatePicker from "react-datepicker";
import { getESPUser } from "../../utils/localStorage";
import MultiSelectAll from "../../common/Multiselect/MultiSelectAll";
import SelectServiceStatusDropdown from "./SelectServiceStatusDropdown";
import CentralizedNotesModal from "../ServiceRequests/Handholder/CentralizedNotesModal";
import withFixedColumns from "react-table-hoc-fixed-columns";
import "react-table-hoc-fixed-columns/lib/styles.css";
import Pagination from "../../common/Pagination/Pagination";
import copysvg from "./../../assets/arrow_copy.svg";
import ic_filter from "./../../assets/ic_filter.svg";
import { toast } from "react-toastify";
import colors from "./../../styles/_colors.scss";
import ESPNotesTrailModal from "./ESPNotesTrailModal";
import ESPSMSTrailModal from "./ESPSMSTrailModal";
import SPLedFilterModel from "./SPLedFilterModel";
import CentralizedSMSLogModal from "../ServiceRequests/Handholder/CentralizedSMSLogModel";
import ESPSMSTrail from "../../containers/EServicePartnerServiceRequests/ESPSMSTrail";
import ESPViewAllNotesModal from "./ESPViewAllNotesModal";
import DePreneurListingModal from "./DePreneurListingModal";
import Checkbox from "../../common/Checkbox/Checkbox";
import { X } from "react-feather";
import api from "../../utils/api";
import { AgGridReact } from "ag-grid-react"
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-material.css';
import rightIcon from '../../assets/right.png'
import wrongIcon from '../../assets/wrong.png'
const ReactTableFixedColumns = withFixedColumns(ReactTable);

export default function ESPServiceRequestGrid(props) {
	//const reactTable = React.createRef(); need this to uncomment
	/*useEffect(() => {
		reactTable.current.props.onPageChange(props.page);
	}, props.page);*/

	const gridRef = useRef()
	const containerStyle = useMemo(() => ({ width: "100%", height: "100%" }), []);
	const gridStyle = useMemo(() => ({ height: "100%", width: "100%" }), []);

	const [updatePriceModal, setUpdatePriceModal] = useState(false)
	const [updatedAmount, setUpdatedAmount] = useState('')
	const [isPriceUpdated, setIsPriceUpdated] = useState(false)
	const [resourceId, setResourceId] = useState('')
	const [loading, setLoading] = useState(false)

	const [applyDiscountModal, setApplyDiscountModel] = useState(false)
	const [discountAmount, setDiscountAmount] = useState('')
	const [originalAmount, setOriginalAmount] = useState('')
	const [originalDiscount, setOriginalDiscount] = useState('')

	const [confirmationModal, setConfirmationModal] = useState(false)
	const [confirmUpdatePriceModal, setConfirmUpdatePriceModal] = useState(false)

	const [marketLinkageModal, setMarketLinkageModal] = useState(false)
	const [marketLinkageModalData, setMarketLinkageModalData] = useState()

	const [umcAvailedDataModal, setUmcAvailedDataModal] = useState(false)
	const [umcAvailedData, setUmcAvailedData] = useState([])

	const [umcTableData, setUmcTableData] = useState([])
	const [catalogueLink, setCatalogueLink] = useState("")
	const [loadingInModal, setLoadingInModal] = useState(false)
	const [TagModalLoading, setTagModalLoading] = useState(false)

	const [confirmationChecked, setConfirmationChecked] = useState(false)

	const [confCodeEligibleOptions, setConfCodeEligibleOptions] = useState([
        {"value": "Yes", "label": "Yes"},
        // {"value":"No", "label": "No"}
    ])

    const [selectedConfCode, setSelectedConfCode] = useState([]);

    const confCodeEligibleOptionChange = (option, originalRowData) => {
        console.log(option, ">>> option on select of confCodeEligibleOptionChange");
        console.log(originalRowData, ">>>>originalRowData");
        
        setSelectedConfCode(option);
    
        if(option?.value === "Yes") {
         // Trigger the updateConfirmationFlagData only if "Yes" is selected
         updateConfirmationFlagData(originalRowData); // Pass the original row data
        }
     };

	const [tagModal, setTagModal] = useState(false)

	const [productLists, setProductLists] = useState([]);
    const [openViewProductModel, setOpenProductModel] = useState(false);

    const handleProductListModel = () => {
        console.log(">>>> Product List table model open clicked");
        console.log(productLists, ">>>> product lists");
        setOpenProductModel(true)
    }

    const handleCloseProductListMoal = () => {
        setOpenProductModel(false)
    }

    const productListColumnDefs = [
        {
            headerName: 'Product Name',
            field: 'name',
            flex: 2,
        },
        {
            headerName: 'Product Price',
            field: 'price',
            flex: 1,
        }
    ]

	const gstRate = 0.18; // 18% GST Rate
	const basePrice = originalAmount / (1 + gstRate) // Base Price of Service Excluding GST


	const updatePriceButton = () => {
		if (updatedAmount && Number(updatedAmount) > 0) {
			setLoading(true)
			let payload = {
				nResourceInstanceId: resourceId,
				fAmountFull: Number(updatedAmount)
			}
			api.updatePriceApi(payload)
				.then(({ data }) => {
					setLoading(false)
					console.log("Updated Price Data: ", data)
					toast("Price Updated Successfully.", {
						type: toast.TYPE.SUCCESS,
					});
					// api.sendPaymentLink({
					//     nResourceInstanceId: resourceId
					// }).then(() => {
					//     toast("Sent Payment Link", {
					//         type: toast.TYPE.SUCCESS,
					//     });
					// })
					openPriceUpdateModalisFalse()
					setUpdatedAmount('')
					props.getExternalPartnerServices()
					// props.getMyServiceRequestsForInterval()
					setIsPriceUpdated(true)
				})
		} else if (updatedAmount && Number(updatedAmount) === 0) {
			openConfirmUpdateModalisTrue()
		} else {
			toast("Please Input Price", {
				type: toast.TYPE.ERROR,
			});
		}
	}

	const confirmUpdateModalClick = () => {
		openConfirmUpdateModalisFalse()
		setLoading(true)
		let payload = {
			nResourceInstanceId: resourceId,
			fAmountFull: Number(updatedAmount)
		}
		api.updatePriceApi(payload)
			.then(({ data }) => {
				setLoading(false)
				toast("Service Moved to SPM", {
					type: toast.TYPE.SUCCESS,
				});
				openPriceUpdateModalisFalse()
				setUpdatedAmount('')
				props.getExternalPartnerServices()
				setIsPriceUpdated(true)
			})
	}

	const applyDiscountBtn = () => {
		if (discountAmount > basePrice) {
			toast("Discount Amount cant be greater than Original Amount", {
				type: toast.TYPE.ERROR,
			});
		} else if (discountAmount === "0") {
			toast("Discount Amount Cannot be Zero (0)", {
				type: toast.TYPE.ERROR,
			});
		} else {
			openConfirmationModalisTrue()
		}
	}

	const confirmDiscount = () => {
		let payload = {
			nResourceInstanceId: resourceId,
			fDiscountAmount: Number(discountAmount)
		}
		api.applyDiscountAPI(payload)
			.then(({ data }) => {
				console.log("Discount Data", data)
				toast("Discount Applied Successfully.", {
					type: toast.TYPE.SUCCESS,
				});
				openConfirmationModalisFalse()
				openApplyDiscountModalisFalse()
				props.getExternalPartnerServices()
			})
	}

	const resendPaymentLink = () => {
		api.sendPaymentLink({
			nResourceInstanceId: resourceId
		}).then(({ data }) => {
			console.log("Pay=", data)
			if (data.message.status == 'error') {
				toast(data.message.message, {
					type: toast.TYPE.ERROR,
				});
			} else {
				toast("Sent Payment Link", {
					type: toast.TYPE.SUCCESS,
				});
			}
		})
	}

	const resendPaymentLinkSPM = () => {
		api.sendPaymentLinkSPM({
			nResourceInstanceId: resourceId
		}).then(({ data }) => {
			if (data.message.status_code === "0") {
				toast("Payment link sent successfully", {
					autoClose: 5000,
					type: toast.TYPE.SUCCESS,
				});
			} else {
				toast(data.message.message, {
					type: toast.TYPE.ERROR,
				})
			}
		})
	}

	const getCouponExpiryDate = (request) => {
		return "Coupon Expiry Date: " + moment(request.dtCouponExpiryDate).format("lll");
	};

	const openUmcAvailedDataModalIsTrue = () => {
		setUmcAvailedDataModal(true)
	}

	const openUmcAvailedDataModalIsFalse = () => {
		setUmcAvailedDataModal(false)
		setUmcAvailedData([])
	}

	const openPriceUpdateModalisTrue = () => {
		setUpdatePriceModal(true)
	}

	const openPriceUpdateModalisFalse = () => {
		setUpdatePriceModal(false)
		setUpdatedAmount('')
	}

	const openMarketLinkageModalisTrue = () => {
		setMarketLinkageModal(true)
	}

	const openMarketLinkageModalisFalse = () => {
		setMarketLinkageModal(false)
		setUmcTableData([])
		setProductLists([])
		setCatalogueLink("")
	}

	const openTagModalisTrue = () => {
		setTagModal(true)
		getTagsDropdown()
		getTagsForUser()
		// setSelectedOptions([{label: 'Fragrance', value: 'Fragrance'}])
	}

	const openTagModalisFalse = () => {
		setTagModal(false)
		setSelectedOptions([])
	}

	const openApplyDiscountModalisTrue = () => {
		setApplyDiscountModel(true)
	}

	const openApplyDiscountModalisFalse = () => {
		setApplyDiscountModel(false)
		setDiscountAmount('')
	}

	const openConfirmationModalisTrue = () => {
		setConfirmationModal(true)
	}

	const openConfirmationModalisFalse = () => {
		setConfirmationModal(false)
	}

	const openConfirmUpdateModalisTrue = () => {
		setConfirmUpdatePriceModal(true)
	}

	const openConfirmUpdateModalisFalse = () => {
		setConfirmUpdatePriceModal(false)
	}



	const copyToClipboard = (content) => {
		const el = document.createElement('textarea');
		el.value = content;
		document.body.appendChild(el);
		el.select();
		document.execCommand('copy');
		document.body.removeChild(el);
	};

	const getSelectedItem = (Options, value) => {
		if (!Options) return;
		const found = find(Options, {
			value: value,
		});
		if (found) {
			return found;
		}
		return;
	};

	const getShowChargesColumn = () => {
		var user = getESPUser();
		// console.log("ESP User", user)

		if (user && user.email === "marketconnect@deasra.co.in") {
			return true
		}

		if (user && user?.external_partner_details && user?.external_partner_details.sServicePartnerOrg && user?.external_partner_details.sServicePartnerOrg.includes("Vakilsearch")) {
			return true;
		}
		return false;
	}

	const hideFilters = () => {
		var user = getESPUser();
		console.log("sServiceCode_list", user?.external_partner_details?.sServiceCode_list)

		const serviceCodeList = user?.external_partner_details?.sServiceCode_list;
		const requiredCodes = [
			"MKTLINKAGEEXHIBITION",
			"MKTLINKAGEBULKBUYER",
			"MKTLINKAGECORPLINKAGE",
			"MKTLINKAGEEXPORT",
			"MKTLINKAGEECOM",
			"MKTLINKAGESHOPINSHOP",
		];

		if (user && requiredCodes.every(code => serviceCodeList.includes(code))) {
			return true;
		}

		return false;
	}

	const getNoShowField = () => {
		var user = getESPUser();
		// console.log("ESP User", user)

		if (user && user.email === "marketconnect@deasra.co.in") {
			return true
		}

		return false;
	}

	const shouldVisibleNoShow = getNoShowField();
	const shouldHideFilters = hideFilters();
	console.log("Should hide filters:", shouldHideFilters);

	const getShowdePrenuersColumn = () => {
		if (props.isForAdmin) {
			if (props.ExternalServicePartnerOrganization && props.ExternalServicePartnerOrganization.includes("DeAsra dePreneur")) {
				return true;
			}
			return false;
		}
		else {
			var user = getESPUser();
			if (user && user?.external_partner_details && user?.external_partner_details.sServicePartnerOrg && user?.external_partner_details.sServicePartnerOrg.includes("DeAsra dePreneur")) {
				return true;
			}
			return false;
		}
	}

	const getShowdeOfflineMeet = (sServiceCode) => {
		console.log(sServiceCode);
		console.log("sServiceCode")
		if (sServiceCode == "asdas") {
			return true;
		}
		else {
			return false;
		}
		// if(props.isForAdmin)
		// {
		// 	return true;
		// }
		// else
		// {
		// 	var user=getESPUser();
		// 	if (user&&user.external_partner_details&&(user.external_partner_details.sServicePartnerEmail == "bmkawhale@gmail.com" || user.external_partner_details.sServicePartnerEmail == "amit.deasra@gmail.com" || user.external_partner_details.sServicePartnerEmail == "udyamfoodservices@gmail.com" || user.external_partner_details.sServicePartnerEmail == "skgkudyam@gmail.com"))
		// 	{
		// 		return true;
		// 	}
		// 	return false;
		// }		
	}

	const getSelectedItemLable = (Options, value) => {
		if (!Options) return;
		const found = find(Options, {
			value: value,
		});
		if (found) {
			return found.label;
		}
		return;
	};

	const [showViewAllNotesModal, setShowViewAllNotesModal] = useState(false);
	const [selectedCustomerEmailId, setselectedCustomerEmailId] = useState(null);
	const [selectedCustomerUserID, setselectedCustomerUserID] = useState(null);
	const [selectedSPLedService, setselectedSPLedService] = useState(null);
	const toggleViewAllNotesModal = () => {
		setShowViewAllNotesModal(!showViewAllNotesModal);
	};

	const handleViewAllNotes = (original) => {
		setselectedSPLedService(original);
		setselectedCustomerEmailId(original.sEmailAddress);
		toggleViewAllNotesModal();
	};

	/*Notes trail modal callbacks */
	const [showNotesTrailModal, setShowNotesTrailModal] = useState(false);
	const [selectednResourceInstanceID, setSelectednResourceInstanceID] = useState(null);
	const toggleNotesTrailModal = () => {
		setShowNotesTrailModal(!showNotesTrailModal);
	};
	const handleViewNotesTrail = (original) => {
		setSelectednResourceInstanceID(original.nResourceInstanceId);
		toggleNotesTrailModal();
	};
	/*End */

	/*SMS trail modal callbacks */
	const [showSMSTrailModal, setShowSMSTrailModal] = useState(false);
	const toggleSMSTrailModal = () => {
		setShowSMSTrailModal(!showSMSTrailModal);
	};
	const handleViewSMSTrail = (original) => {
		setSelectednResourceInstanceID(original.nResourceInstanceId);
		toggleSMSTrailModal();
	};
	/*End */

	const [showViewAllSMSModal, setShowViewAllSMSModal] = useState(false);
	const toggleViewAllSMSModal = () => {
		setShowViewAllSMSModal(!showViewAllSMSModal);
	};

	const handleViewAllSMS = (original) => {
		setselectedSPLedService(original);
		setselectedCustomerEmailId(original.sEmailAddress);
		toggleViewAllSMSModal();
	};

	const getServiceCostAmountAfterDiscount = (originalAmount, discountAmount, fdeAsraPlatformCharges, fPackageOfferGST) => {
        const gstRate = 0.18; // 18% GST Rate
        const basePrice = originalAmount / (1 + gstRate)
        const discountedPrice = Math.round(basePrice) - Math.round(discountAmount)
        // const serviceCostAfterDiscountIncludingGst = discountedPrice * 1.18
        // return serviceCostAfterDiscountIncludingGst.toFixed(2)
		let serviceCostAfterDiscountIncludingGst = discountedPrice * 1.18
        if (fdeAsraPlatformCharges !== null && fdeAsraPlatformCharges > 0) {
            serviceCostAfterDiscountIncludingGst += fdeAsraPlatformCharges + (fPackageOfferGST || 0);
        }
        return Math.round(serviceCostAfterDiscountIncludingGst)
    }

	const processTags = (tags) => {
		if (tags !== null && tags !== '[]') {
			let parsedTags = [];

			try {
				// Replace single quotes with double quotes to make it valid JSON
				const validJsonString = tags.replace(/'/g, '"');
				parsedTags = JSON.parse(validJsonString);
			} catch (error) {
				console.error("Invalid JSON:", error);
				return "";
			}

			// Ensure parsedTags is an array
			if (!Array.isArray(parsedTags)) {
				console.error("Parsed value is not an array");
				return "";
			}

			return parsedTags.join(', ');
		}
	};

	// const confCodeEligibleOptionChange = (option, originalRowData) => {
    //     console.log(option, ">>> option on select of confCodeEligibleOptionChange");
    //     console.log(originalRowData, ">>>>originalRowData");
        
    //     setSelectedConfCode(option);
    
    //     if(option?.value === "Yes") {
    //      // Trigger the updateConfirmationFlagData only if "Yes" is selected
    //      updateConfirmationFlagData(originalRowData); // Pass the original row data
    //     }
    //  };

	const handleCheckBoxChange = (e) => {
		e.preventDefault();
		console.log(">>>>checkbox clicked");
		// console.log(originalRowData, ">>>>originalRowData on checkbox Click");
	}

	const columns = [
		{
			id: "dtRequested",
			headerStyle: { 'whiteSpace': 'unset', 'borderBottom': 'solid 1px #ccc' },
			Header: "Request Date",
			accessor: "dtRequested",
			style: { 'whiteSpace': 'unset' },
			width: 120,
			Cell: ({ original }) =>
				original.dtRequested ? (moment(original.dtRequested).format("DD/MM/YYYY")) : ("NA"),
			// getProps: (state, rowInfo, column) => {
			// 	return {
			// 		style: {
			// 			background: rowInfo && rowInfo.viewIndex === props.ExpandedChange["selectedRow"] ? '#F4DFF4' : null,
			// 		},
			// 	};
			// },
		},
		{
			id: "cs_" + "nResourceInstanceId",
			Header: "Call Connected",
			headerStyle: { 'whiteSpace': 'unset', 'borderBottom': 'solid 1px #ccc' },
			accessor: "nResourceInstanceId",
			show: !getShowChargesColumn(),
			width: 110,
			style: { 'whiteSpace': 'unset' },
			getProps: (state, rowInfo, column) => {
				return {
					style: {
						overflow: "visible",
					},
				};
			},
			Cell: ({ original }) => (
				<>
					<span>{getSelectedItemLable(props.callStatusOptions, original.sCallStatus) || ""}</span>
				</>
			)
		},


		{
			id: "cs_" + "nResourceInstanceId",
			Header: "Offline Meet",
			headerStyle: { 'whiteSpace': 'unset', 'borderBottom': 'solid 1px #ccc' },
			accessor: "nResourceInstanceId",
			show: !getShowChargesColumn(),
			width: 110,
			style: { 'whiteSpace': 'unset' },
			getProps: (state, rowInfo, column) => {
				return {
					style: {
						overflow: "visible",
					},
				};
			},
			Cell: ({ original }) => (
				<>
					<span>{getSelectedItemLable(props.offlinemeetoptions, original.bOfflineMeet) || ""}</span>
				</>
			)
		},


		{
			id: "custrefSRState",
			Header: "Service Status",
			headerStyle: { 'whiteSpace': 'unset', 'borderBottom': 'solid 1px #ccc' },
			accessor: "custrefSRState",
			style: { 'whiteSpace': 'unset' },
			Cell: ({ original }) => (
				<>
					{
						original.custrefSRState == "Cancelled" || original.custrefSRState == "Delivered" ?
							(
								<span>{original.custrefSRState}</span>
							) :
							(
								<span>
									{
										original.sPaymentReceiver == "Partner" ?
											(
												original.refExternalServicePartner === "Mr. Sudhir Gijare" ? 
												
												(
												original.custrefSRState == "Prepared" ||
													original.custrefSRState == "Ready For Progression" ?
													"Willing to Pay" :
													original.custrefSRState == "Partial/ Full Payment Pending" ?
														"Willing to Pay" :
														original.custrefSRState == "Payment Confirmed By Partner" ?
															"Payment Received" :
															original.custrefSRState
											) :
												original.custrefSRState == "Prepared" ? original?.nPackageInstanceId ? "Willing to Pay" : "Quotation Sent" :
													original.custrefSRState == "Ready For Progression" ?
													// "Willing to Pay" :
													"Payment Received" :
													original.custrefSRState == "Partial/ Full Payment Pending" ?
														"Willing to Pay" :
														original.custrefSRState == "Payment Confirmed By Partner" ?
															"Payment Received" :
															original.custrefSRState === "Info & Docs Received"
															? "Awaiting for information/Documents"
															: original.custrefSRState 
											) :
										original.custrefSRState == "Prepared" || original.custrefSRState == "Partial/ Full Payment Pending" ?
												"Willing to Pay" :
												original.custrefSRState == "Payment Received" ||
													original.custrefSRState == "Ready For Progression" ?
													"Payment Received" :
													original.custrefSRState
									}
								</span>
							)
					}
				</>
			)
		},
		{
			id: "sServiceName",
			Header: "Service Name",
			headerStyle: { 'whiteSpace': 'normal', 'borderBottom': 'solid 1px #ccc' },
			accessor: "sServiceName",
			Cell: ({ original }) => (
				<span style={{ whiteSpace: 'pre-wrap' }}>
					{
						(original.sServiceCode === "MKTLINKAGEEXHIBITION" || original.sServiceCode === "MKTLINKAGEBULKBUYER" ||
							original.sServiceCode === "MKTLINKAGEECOM" || original.sServiceCode === "MKTLINKAGECORPLINKAGE" ||
							original.sServiceCode === "MKTLINKAGESHOPINSHOP" || original.sServiceCode === "MKTLINKAGEEXPORT") && original.sServiceDisplayName ?
							original.sServiceName ?
								original.sServiceName + " " + `(${original.sServiceDisplayName})` :
								original.refServiceType ?
									original.refServiceType.sServiceName + " " + `(${original.sServiceDisplayName})` :
									""
							:
							original.sServiceName ?
								original.sServiceName :
								original.refServiceType ?
									original.refServiceType.sServiceName :
									""
					}
				</span>
			),
		},
		{
			id: "sPackageOfferTitle",
			Header: "Package/Offering Title",
			headerStyle: { 'whiteSpace': 'unset', 'borderBottom': 'solid 1px #ccc' },
			accessor: "sPackageOfferTitle",
			show: !getShowChargesColumn(),
			Cell: ({ original }) => (
				original.sPackageOfferTitle ?
					original.sPackageOfferTitle :
					""
			),
		},
		{
			id: "stag",
			Header: "Tags",
			show: getShowChargesColumn(),
			style: { 'whiteSpace': 'unset' },
			headerStyle: { 'whiteSpace': 'unset', 'borderBottom': 'solid 1px #ccc' },
			accessor: "stag",
			Cell: ({ value }) => <div className='text-center'>{processTags(value)}</div>
		},
		// {
		// 	id: "sFirstName",
		// 	Header: "Customer Name",
		// 	style: { 'whiteSpace': 'unset' },
		// 	headerStyle: { 'whiteSpace': 'unset', 'borderBottom': 'solid 1px #ccc' },
		// 	accessor: "sFirstName",
		// 	Cell: ({ original }) => (
		// 		<>
		// 			<div className={"conv-float-left conv-mr5"}>
		// 				{
		// 					original.bNeedToTalkToSP ? (<><div className={"blue-dot"}></div><br></br></>) : ("")
		// 				}
		// 				{
		// 					original.sExternalHHEmail ? (<><div className={"green-dot"}></div></>) : ("")
		// 				}
		// 			</div>
		// 			{
		// 				`${original.sFirstName ?
		// 					original.sFirstName :
		// 					original.customer_meta ?
		// 						original.customer_meta.first_name :
		// 						""
		// 				}${' '}
		// 				${original.sLastName ?
		// 					original.sLastName :
		// 					original.customer_meta ?
		// 						original.customer_meta.last_name :
		// 						""
		// 				}`
		// 			}
		// 		</>
		// 	),
		// },
		// {
		// 	id: "sEmailAddress",
		// 	Header: "Customer Email ID",
		// 	headerStyle: { 'whiteSpace': 'unset', 'borderBottom': 'solid 1px #ccc' },
		// 	accessor: "sEmailAddress",
		// 	Cell: ({ original }) => (
		// 		<>
		// 			<img
		// 				alt="copy"
		// 				src={copysvg}
		// 				height={"20px"}
		// 				width={"16px"}
		// 				className="con-cursor-pointer conv-mr13"
		// 				onClick={(e) => {
		// 					e.preventDefault();
		// 					copyToClipboard(original.sEmailAddress);
		// 					toast(`${original.sFirstName ?
		// 						original.sFirstName :
		// 						original.customer_meta ?
		// 							original.customer_meta.first_name :
		// 							""
		// 						}${' '}
		// 					${original.sLastName ?
		// 							original.sLastName :
		// 							original.customer_meta ?
		// 								original.customer_meta.last_name :
		// 								""
		// 						}'s Email Copied!`, {
		// 						autoClose: 5000,
		// 						type: toast.TYPE.SUCCESS,
		// 					});
		// 				}}
		// 			/>
		// 			{
		// 				(original.sServiceCode === "MKTLINKAGEEXHIBITION" || original.sServiceCode === "MKTLINKAGEBULKBUYER" ||
		// 				original.sServiceCode === "MKTLINKAGEECOM" ||original.sServiceCode === "MKTLINKAGECORPLINKAGE" ||
		// 				original.sServiceCode === "MKTLINKAGESHOPINSHOP" ||original.sServiceCode === "MKTLINKAGEEXPORT") ?
		// 					<span style={{textDecoration: 'underline', color: '#78417C', cursor: "pointer"}} onClick={() => getUserDetails(original)}>
		// 						{
		// 							original.sEmailAddress
		// 						}
		// 					</span>
		// 				:
		// 					<span onClick={() => getUserDetails(original)}>
		// 						{
		// 							original.sEmailAddress
		// 						}
		// 					</span>
		// 			}
		// 		</>
		// 	),
		// },
		// {
		// 	id: "sContactNumber",
		// 	Header: "Phone No.",
		// 	width: 120,
		// 	headerStyle: { 'whiteSpace': 'unset', 'borderBottom': 'solid 1px #ccc' },
		// 	accessor: "sContactNumber",
		// 	Cell: ({ original }) => (
		// 		<>
		// 		{/* <span onClick={() => getUserDetails(original)}>
		// 			{
		// 				original.sContactNumber
		// 			}
		// 			</span> */}

		// 			{
		// 				(original.sServiceCode === "MKTLINKAGEEXHIBITION" || original.sServiceCode === "MKTLINKAGEBULKBUYER" ||
		// 					original.sServiceCode === "MKTLINKAGEECOM" || original.sServiceCode === "MKTLINKAGECORPLINKAGE" ||
		// 					original.sServiceCode === "MKTLINKAGESHOPINSHOP" || original.sServiceCode === "MKTLINKAGEEXPORT") ?
		// 					<span style={{ textDecoration: 'underline', color: '#78417C', cursor: "pointer" }} onClick={() => getUserDetails(original)}>
		// 						{
		// 							original.sContactNumber
		// 						}
		// 					</span>
		// 					:
		// 					<span onClick={() => getUserDetails(original)}>
		// 						{
		// 							original.sContactNumber
		// 						}
		// 					</span>
		// 			}
		// 		</>
		// 	)
		// },

		{
			id: 'sEmailAddress',
			Header: 'Customer Details',
			style: { 'whiteSpace': 'unset' },
			headerStyle: { 'whiteSpace': 'unset', 'borderBottom': 'solid 1px #ccc' },
			// accessor: "sEmailAddress",
			width: 350,
			Cell: ({ original }) => (
				<>
				{/* {console.log(original, ">>>>>>>>>>original")} */}
					<div className={"conv-float-left"}>

						<div style={{
							display: 'flex',justifyContent: 'space-between'
						}}> 
							<div>
							<span className="conv-float-left conv-mr5 lpm-service-grid-key" style={{ width: '80px' }}>Instance Id:</span>
							{
								original.nResourceInstanceId ?
									(
										<>
											<span className="lpm-service-grid-value conv-mr10" style={{ wordBreak: "break-all"}}>
												{
													`${original.nResourceInstanceId &&
													original.nResourceInstanceId
													}`
												}
											</span>
										</>
									)
									:
									<span className="lpm-service-grid-value conv-mr13 conv-ml10" style={{ wordBreak: "break-all" }}>
										{("NA")}
									</span>
							}
							</div>
							<div>
							<span className="conv-mr5 lpm-service-grid-key">JPMC: {" "}</span>
							{
								original.JPMC_eligible === "Yes" ?
<span className="lpm-service-grid-value conv-mr10" style={{ wordBreak: "break-all"}}>
								<img src={rightIcon} alt="" width={20} height={20}/>
							</span>
								:
								<span className="lpm-service-grid-value conv-mr10" style={{ wordBreak: "break-all"}}>
								<img src={wrongIcon} alt="" width={20} height={20}/>
							</span>
							}
							{/* <span className="lpm-service-grid-value conv-mr10" style={{ wordBreak: "break-all"}}>
								<img src={wrongIcon} alt="" width={20} height={20}/>
							</span> */}
							</div>
						</div>
						<div style={{ "clear": "both" }}></div>
						<div className="conv-mt10">
							<span className="conv-float-left conv-mr5 lpm-service-grid-key" style={{ width: '80px' }}>Name:</span>
							{
								original.sFirstName && original.sLastName ?
									(
										<>
											<span className="lpm-service-grid-value conv-mr10" style={{ wordBreak: "break-all", float: "right", width: "230px" }}>
												{
													`${original.sFirstName ?
														original.sFirstName :
														original.customer_meta ?
															original.customer_meta.first_name :
															""
													}${' '}
																${original.sLastName ?
														original.sLastName :
														original.customer_meta ?
															original.customer_meta.last_name :
															""
													}`
												}
											</span>
										</>
									)
									:
									<span className="lpm-service-grid-value conv-mr13 conv-ml10" style={{ wordBreak: "break-all", float: "right", width: "200px" }}>
										{("NA")}
									</span>
							}
						</div>

						<div style={{ "clear": "both" }}></div>
						{/* Adding confirmation recd. below name */}
						{
							shouldHideFilters && (
								<div style={{display:"none"}}>
									<div className="r-checkbox" style={{
										width: 'max-content',
										display: 'flex',
										gap: '10px',
										alignItems: 'center',
										justifyContent: 'center',
										marginTop: 7
									}}>
										<input type="checkbox"
											style={{
												width: 18,
												height: 18,
												cursor:"pointer"
											}}
											checked={original.bConfirmation_tag}
											onChange={(e) => {
												e.stopPropagation();
												// setConfirmationChecked(!confirmationChecked)
												updateConfirmationFlagData(original)
												// props.getExternalPartnerServices()
											}}
											disabled={original.bConfirmation_tag}
										/>
										<label>Confirmation Received</label>
									</div>
								</div>
							)
						}
						<div style={{ "clear": "both" }}></div>
						{
							shouldHideFilters && (
								<>
								<div className="conv-mt10">
							<span className="conv-float-left conv-mr5 lpm-service-grid-key" style={{ width: '80px' }}>EntryPoint:</span>
							{
								original.sEntryPoint ?  
									(
										<>
											<span className="lpm-service-grid-value conv-mr10" style={{ wordBreak: "break-all", float: "right", width: "230px" }}>
												{/* {
													`${original.sFirstName ?
														original.sFirstName :
														original.customer_meta ?
															original.customer_meta.first_name :
															""
													}${' '}
																${original.sLastName ?
														original.sLastName :
														original.customer_meta ?
															original.customer_meta.last_name :
															""
													}`
												} */}
												{original.sEntryPoint}
											</span>
										</>
									)
									:
									<span className="lpm-service-grid-value conv-mr10" style={{ wordBreak: "break-all", float: "right", width: "230px" }}>
										{("NA")}
									</span>
							}
						</div>
						<div style={{ "clear": "both" }}></div>
								</>
							)
						}
						<div className="conv-mt10">
							<span className="conv-float-left conv-mr5 lpm-service-grid-key" style={{ width: '80px' }}>Email:</span>



							{
								(original.sServiceCode === "MKTLINKAGEEXHIBITION" || original.sServiceCode === "MKTLINKAGEBULKBUYER" ||
									original.sServiceCode === "MKTLINKAGEECOM" || original.sServiceCode === "MKTLINKAGECORPLINKAGE" ||
									original.sServiceCode === "MKTLINKAGESHOPINSHOP" || original.sServiceCode === "MKTLINKAGEEXPORT") ?
									<div style={{ justifyContent: 'flex-start', display: 'flex', textDecoration: 'underline', color: '#78417C' }} >
										<span className="lpm-service-grid-value" style={{ textDecoration: 'underline', color: '#78417C', cursor: "pointer", float: "right" }} onClick={() => getUserDetails(original)}>
										{
											original.sEmailAddress
										}
										</span>
										<img
											alt="copy"
											src={copysvg}
											height={"20px"}
											width={"16px"}
											className="con-cursor-pointer conv-mr13 conv-ml10"
											onClick={(e) => {
												e.preventDefault();
												copyToClipboard(original.sEmailAddress);
												toast(`${original.sFirstName ?
													original.sFirstName :
													original.customer_meta ?
														original.customer_meta.first_name :
														""
													}${' '}
							${original.sLastName ?
														original.sLastName :
														original.customer_meta ?
															original.customer_meta.last_name :
															""
													}'s Email Copied!`, {
													autoClose: 5000,
													type: toast.TYPE.SUCCESS,
												});
											}}
										/>
									</div>
									:
									<div style={{ justifyContent: 'flex-start', display: 'flex', }} onClick={() => getUserDetails(original)}>
										<span className="lpm-service-grid-value" style={{ cursor: "pointer", wordBreak: "break-all", float: "right" }}></span>
										{
											original.sEmailAddress
										}
										<img
											alt="copy"
											src={copysvg}
											height={"20px"}
											width={"16px"}
											className="con-cursor-pointer conv-mr13 conv-ml10"
											onClick={(e) => {
												e.preventDefault();
												copyToClipboard(original.sEmailAddress);
												toast(`${original.sFirstName ?
													original.sFirstName :
													original.customer_meta ?
														original.customer_meta.first_name :
														""
													}${' '}
							${original.sLastName ?
														original.sLastName :
														original.customer_meta ?
															original.customer_meta.last_name :
															""
													}'s Email Copied!`, {
													autoClose: 5000,
													type: toast.TYPE.SUCCESS,
												});
											}}
										/>
									</div>
							}

						</div>
						<div style={{ "clear": "both" }}></div>
						<div className="conv-mt10">
							<span className="conv-float-left conv-mr5 lpm-service-grid-key" style={{ width: '80px' }}>Contact:</span>
							{
								(original.sServiceCode === "MKTLINKAGEEXHIBITION" || original.sServiceCode === "MKTLINKAGEBULKBUYER" ||
									original.sServiceCode === "MKTLINKAGEECOM" || original.sServiceCode === "MKTLINKAGECORPLINKAGE" ||
									original.sServiceCode === "MKTLINKAGESHOPINSHOP" || original.sServiceCode === "MKTLINKAGEEXPORT") ?
									(
										<div style={{ justifyContent: 'flex-start', display: 'flex', }}>
											<span className="lpm-service-grid-value conv-mr10" style={{ wordBreak: "break-all", float: "right", textDecoration: 'underline', color: '#78417C', }} onClick={() => getUserDetails(original)}>
												{
													original.sContactNumber
												}
											</span>
											<img
											alt="copy"
											src={copysvg}
											height={"20px"}
											width={"16px"}
											className="con-cursor-pointer conv-mr13 conv-ml10"
											onClick={(e) => {
												e.preventDefault();
												copyToClipboard(original.sContactNumber);
												toast(`${original.sFirstName ?
													original.sFirstName :
													original.customer_meta ?
														original.customer_meta.first_name :
														""
													}${' '}
							${original.sLastName ?
														original.sLastName :
														original.customer_meta ?
															original.customer_meta.last_name :
															""
													}'s Contact Copied!`, {
													autoClose: 5000,
													type: toast.TYPE.SUCCESS,
												});
											}}
										/>
										</div>
									)
									:
									<div style={{ justifyContent: 'flex-start', display: 'flex', }}>
										<span className="lpm-service-grid-value conv-mr10" style={{ wordBreak: "break-all", float: "right" }}>
											{
												original.sContactNumber
											}
										</span>
										<img
											alt="copy"
											src={copysvg}
											height={"20px"}
											width={"16px"}
											className="con-cursor-pointer conv-mr13 conv-ml10"
											onClick={(e) => {
												e.preventDefault();
												copyToClipboard(original.sContactNumber);
												toast(`${original.sFirstName ?
													original.sFirstName :
													original.customer_meta ?
														original.customer_meta.first_name :
														""
													}${' '}
							${original.sLastName ?
														original.sLastName :
														original.customer_meta ?
															original.customer_meta.last_name :
															""
													}'s Contact Copied!`, {
													autoClose: 5000,
													type: toast.TYPE.SUCCESS,
												});
											}}
										/>
									</div>
							}
						</div>
					</div>
				</>
			),
		},


	];

	//getVerificationStatus

	// const [verified, setVerified] = useState('')

	// const verifiedStatus = (e) => {
	//     console.log("EEEEE", e)
	//     setVerified('')
	//     if (e.sServiceCode === "DEPRELISTING") {
	//         let payload = {
	//             api_key: '82mqEyJnct4kzC8y',
	//             resource_instance_id: e.nResourceInstanceId
	//         }
	//         // console.log("PAYOAD==", payload)
	//         api.getVerifiedStatus(payload).then(({data}) => {
	//             console.log("PAYOAD==", data.data)
	//                 if (data.ErrorCode === 200) {
	//                     setVerified(data.data.status)
	//                 }
	//             // setVerified(data.data.status)
	//         })
	//     }
	// }

	// const rowData = [
	// 	{
	// 		type: 'Export',
	// 		oppOffered: '10',
	// 		oppAvailed: '10'
	// 	},
	// 	{
	// 		type: 'Exhibition',
	// 		oppOffered: '10',
	// 		oppAvailed: '7'
	// 	},
	// 	{
	// 		type: 'Shop in Shop',
	// 		oppOffered: '10',
	// 		oppAvailed: '5'
	// 	}
	// ]

	const onAvailedCountClick = (data) => {
		// openUmcAvailedDataModalIsTrue()
		setLoadingInModal(true)
		const {tempUMCAvailedTable} = api.umcOppurtunitiesOfUserApiAllDetails({
			nUserId: data.nUserId,
			sServiceCodes: data.sServiceCode
		}).then(({data}) => {
			setLoadingInModal(false)
			console.log("Service Data", data.data[0]['Availed Details'])
			setUmcAvailedData(data.data[0]['Availed Details'])
			openUmcAvailedDataModalIsTrue()
		})
	}

	const columnDefs = [
		{
			headerName: 'Type',
			field: 'sServiceCode',
			width: 300,
			valueFormatter: params => {
				switch (params.value) {
					case 'MKTLINKAGEBULKBUYER':
						return 'Bulk Buyer';
					case 'MKTLINKAGEECOM':
						return 'E Commerce';
					case 'MKTLINKAGECORPLINKAGE':
						return 'Corporate Linkage';
					case 'MKTLINKAGESHOPINSHOP':
						return 'Shop in Shop';
					case 'MKTLINKAGEEXHIBITION':
						return 'Exhibition';
					case 'MKTLINKAGEEXPORT':
						return 'Exports';
					default:
						return params.value;
				}
			},
			// cellStyle: { textAlign: "right" },
			// valueFormatter: params => numberFormatter.format(params.value),
			// headerComponentFramework: (params) => {
			//   return (
			// 	<div style={{ display: "flex", justifyContent: 'center', width: '100%', alignItems: "center" }}>
			// 	  <div>{params.displayName}</div>
			// 	</div>
			//   );
			// },
		},
		{
			headerName: 'Opportunities Offered',
			field: 'Oppu Interested',
			flex: 1,
			// cellStyle: { textAlign: "right" },
			// valueFormatter: params => numberFormatter.format(params.value),
			// headerComponentFramework: (params) => {
			//   return (
			// 	<div style={{ display: "flex", justifyContent: 'center', width: '100%', alignItems: "center" }}>
			// 	  <div>{params.displayName}</div>
			// 	</div>
			//   );
			// },
		},
		{
			headerName: 'Opportunities Availed',
			field: 'Oppu Availed',
			flex: 1,
			cellRendererFramework: (params) => {
				const value = params.value;
			const row = params.data;

			return (
				<div className=''>
					{value && value !== 0 ? (
						<a
							href='#'
							style={{ textDecoration: 'underline', color: '#78417C' }}
							onClick={() => onAvailedCountClick(row)}
						>
							{value}
						</a>
					) : (
						value
					)}
				</div>
			);
			}
			// cellStyle: { textAlign: "right" },
			// valueFormatter: params => numberFormatter.format(params.value),
			// headerComponentFramework: (params) => {
			//   return (
			// 	<div style={{ display: "flex", justifyContent: 'center', width: '100%', alignItems: "center" }}>
			// 	  <div>{params.displayName}</div>
			// 	</div>
			//   );
			// },
		},
	]

	const columnDefs1 = [
		{
			headerName: 'Resource Id',
			field: 'nResourceInstanceId',
			// flex: 1,
			width:120,
		},
		{
			headerName: 'Opp Title',
			field: 'sServiceDisplayName',
			// flex: 1,
			width:400,
			cellStyle: { 'white-space': 'normal' },
            autoHeight: true,
		},
		{
			headerName: 'Delivered Date',
			field: 'dtDelivered',
			flex: 1,
			valueFormatter: (params) => {
				// Check if there is a date value
				if (params.value) {
					// Create a new Date object from the ISO string
					const date = new Date(params.value);
					// Format it to en-CA (YYYY-MM-DD)
					return date.toLocaleDateString('en-GB');
				}
				return '';
			}
		},
		{
			headerName: 'Company Name',
			field: 'sCompanyName',
			flex: 1,
			valueFormatter: (params) => {
				// Check if the value is "Null"
				return params.value === "Null" ? 'NA' : params.value;
			}
		},
		{
			headerName: 'Company Location',
			field: 'sCompanyLocation',
			flex: 1,
			valueFormatter: (params) => {
				// Check if the value is "Null"
				return params.value === "Null" ? 'NA' : params.value;
			}
		},
	]

	const gridOptions = useMemo(() => ({
		suppressScrollOnNewData: true,
	}), []);
	const [userData, setUserData] = useState()

	const getUserDetails = (e) => {
		if (e.sServiceCode === "MKTLINKAGEBULKBUYER" || e.sServiceCode === "MKTLINKAGEECOM" || e.sServiceCode === "MKTLINKAGECORPLINKAGE" ||
			e.sServiceCode === "MKTLINKAGESHOPINSHOP" || e.sServiceCode === "MKTLINKAGEEXHIBITION" || e.sServiceCode === "MKTLINKAGEEXPORT") {
			setUserData(e)
			console.log("ee", userData)
			openMarketLinkageModalisTrue()
			setLoadingInModal(true)

			let filterParameters = {}

			const { tempUMCTableData } = api.umcOppurtunitiesOfUserApi({
				nUserId: e.nUserId
			}).then(({ data }) => {
				console.log("Data", data)
				setUmcTableData(data.data)
				setLoadingInModal(false)
			})


			let payload = {
				// api_key: "82mqEyJnct4kzC8y",
				api_key: "r54B?rHXUE7v%$9t",
				user_id: e.nUserId
			}

			const { tempCataloguelinkData } = api.catalogueLinkApi(payload)
				.then(({ data }) => {
					console.log("Link", data)
					setCatalogueLink(data?.data?.catalogue_url)
					setProductLists(data?.data?.product_lists)
				})
		}
	}

	//   const [selectedTags, setSelectedTags] = useState([]);
	// const randomTags = ['Tag1', 'Tag2', 'Tag3', 'Tag4', 'Tag5', 'Tag6', 'Tag7', 'Tag8', 'Tag9', 'Tag10']; // Example random tags

	// const handleTagChange = (tag) => {
	//     if (selectedTags.includes(tag)) {
	//         setSelectedTags(selectedTags.filter(t => t !== tag));
	//     } else {
	//         if (selectedTags.length < 5) {
	//             setSelectedTags([...selectedTags, tag]);
	//         } else {
	//             alert("You can only select up to 5 tags.");
	//         }
	//     }
	// };

	const [selectedOptions, setSelectedOptions] = useState([]);
	const [tagsDropDownList, setTagsDropdownList] = useState([])
	const randomTags = [
		{ label: 'Tag1', value: 'tag1' },
		{ label: 'MY Tag #$', value: 'tag2' },
		{ label: 'asfsfsdfsdfsd', value: 'tag3' },
		{ label: 'Tag4', value: 'tag4' },
		{ label: 'Tag5sfsdfsdfsdfsd', value: 'tag5' },
		{ label: 'Tagsfsdfsdfsdf6', value: 'tag6' },
		{ label: 'Tagsfsdfsdfsdfsd7', value: 'tag7' },
		{ label: 'Tag8', value: 'tag8' },
		{ label: 'Tag9', value: 'tag9' },
		{ label: 'Tag10', value: 'tag10' }
	]; // Example random tags

	const handleChange = (selectedList) => {
		if (selectedList.length <= 5) {
			setSelectedOptions(selectedList);
		} else {
			// alert("You can only select up to 5 tags.");
			toast("You can only assign up to 5 tags", {
				type: toast.TYPE.ERROR,
			});
		}
	};

	const onSaveTags = () => {
		if (selectedOptions.length === 0) {
			toast("Please Select Tags first.", {
				type: toast.TYPE.ERROR,
			});
		} else {
			const tags = []

			selectedOptions.map((ele) => {
				tags.push(ele.label)
			})

			let payload = {
				nUserId: userData.nUserId,
				sTag: tags
			}
			setTagModalLoading(true)
			console.log("Selected Tags", payload)
			const { tempSaveTags } = api.saveTagsApi(payload)
				.then(({ data }) => {
					console.log(data)
					setTagModalLoading(false)
					toast("Tags updated successfully.", {
						type: toast.TYPE.SUCCESS,
					});
					getTagsForUser()
				})
		}

	}

	const getTagsDropdown = () => {
		const sectorName = userData?.sBusinessSector ?
			userData.sBusinessSector :
			userData?.refBusinessSectorNew?.sSectorName

		api.tagsListApi(sectorName === "Not Defined" || sectorName === "notdefined" ? "Others" : sectorName)
			.then(({ data }) => {
				if (data.data.length > 0) {
					const formattedData = data.data[0]["sTag"]
						.map((ele) => ({
							value: ele,
							label: ele
						}))

					setTagsDropdownList(formattedData)
					console.log("Drop list", formattedData)
				} else {
					setTagsDropdownList([])
				}

			})
	}

	const getTagsForUser = () => {
		const userId = userData.nUserId
		setTagModalLoading(true)

		api.fetchTagsByUserId(userId)
			.then(({ data }) => {
				const formattedData = data.sTags.map((ele) => ({
					value: ele,
					label: ele
				}))
				setSelectedOptions(formattedData)
				setTagModalLoading(false)
			})
	}

	const styles = {
		selectedTagsContainer: {
			display: 'flex',
			flexWrap: 'wrap',
			marginTop: '10px'
		},
		selectedTag: {
			backgroundColor: '#e0e0e0',
			color: '#333',
			border: '1px solid #ccc',
			borderRadius: '7px',
			padding: '5px 10px',
			margin: '5px',
			fontSize: '14px'
		}
	};

	const updateConfirmationFlagData = (data) => {
		console.log(data, ">>> data in updateConfirmationData");
		
		if (data.refCurrentState) {
			props.setIsLoading(true)
			console.log("Service in SPM")
			const { tempUpdateFlagSPM } = api.updateConfirmationFlagSPM(data.nResourceInstanceId, !data.bConfirmation_tag)
				.then(({ data }) => {
					console.log("Flag", data)
					props.setIsLoading(false)
					toast("Confirmation Received Flag set", {
						type: toast.TYPE.SUCCESS,
					});
					setSelectedConfCode([])
					props.getExternalPartnerServices()
				})
		} else {
			console.log("Service in LPM")
			props.setIsLoading(true)
			const { tempUpdateFlagLPM } = api.updateConfirmationFlagLPM(data.nResourceInstanceId, !data.bConfirmation_tag)
				.then(({ data }) => {
					// api.updatePriceApi({
					// 	nResourceInstanceId: data.nResourceInstanceId,
					// 	fAmountFull: 0
					// })
					// 	.then(({ data }) => {
					// 		const { tempUpdateFlagSPM } = api.updateConfirmationFlagSPM(resourceId, true)
					// 			.then(({ data }) => {
					// 				console.log("Flag", data)
					// 				props.setIsLoading(false)
					// 				props.getExternalPartnerServices()
					// 			})						
					// 	})
					props.setIsLoading(false)
					toast("Confirmation Received Flag set", {
						type: toast.TYPE.SUCCESS,
					});
					setSelectedConfCode([])
					props.getExternalPartnerServices()
				})
		}

	}

	//   useEffect(() => {
	// 	updateConfirmationFlag()
	//   }, [confirmationChecked])

	// console.log(getShowdePrenuersColumn(), ">>>getShowdePrenuersColumn()");
	// console.log(hideFilters(), ">>>hideFilters()");
	// console.log(getShowChargesColumn(), ">>>>getShowChargesColumn()");

	// console.log(props.ExternalServicePartnerOrganization, ">>>>props.ExternalServicePartnerOrganization");
	// console.log(props.externalServicePartnerOptions, ">>>>props.externalServicePartnerOptions");
	console.log(props.onExternalServicePartnerChange, ">>>>props.onExternalServicePartnerChange");
	console.log(props.data, ">>>>>props.data in ESPServiceRequestGrid");
	
	return (
		<div className={`row row-container ${props.isLoading && "set-opacity"}`} >
			{props.isLoading && <Spinner className="center-screen" />}


			<div style={{ clear: "both" }}></div>
			<div className="col-12">
				<div className="row flex-wrap gap-2">

					<button className="con-btn-filled conv-pl15 conv-pr15 conv-font14" style={{ marginLeft: '15px' }}
						onClick={(e) => { props.handleViewFilterModal() }} >
						<img
							alt=""
							src={ic_filter}
							height={"15px"}
							width={"15px"}
							className="conv-mr10"
						/>
						Filter By
					</button>


					<div className="col-md col-sm-6 conv-zindex">
						{shouldHideFilters && (
							<div>
								<Select
									options={props.oppTypeNameList}
									onChange={props.onOppTypeChange}
									value={props.selectedOppType}
									placeholder="Select Opp Type"
									isClearable
								/>
							</div>
						)}
					</div>

					<div className="col-md col-sm-6 conv-zindex">
					{shouldHideFilters && (
						<div className="">
							{/* <Select
								options={props.oppTitleNameList}
								onChange={props.onOppTitleChange}
								value={props.selectedOppTitle}
								placeholder="Select Opp Title"
								isClearable
							/> */}
							<MultiSelectAll
								toggleAll={props.toggleAllOppTitle}
								toggleSelection={props.onOppTitleChange}
								checkboxItemsList={props.oppTitleNameList}
								selectedOptions={props.selectedOppTitle}
								placeholderButtonLabel="Select Opp Title"
							/>
						</div>
						)}
					</div>

					<div className="col-md col-sm-6">
					{shouldHideFilters && (
						<div className="conv-zindex">
							{/* <Select
                          options={props.oppTitleNameList}
                            onChange={props.onOppTitleChange}
                            value={props.selectedOppTitle}
                          placeholder="Select Opp Title"
						  isClearable
                      /> */}
							<MultiSelectAll
								toggleAll={props.toggleAllSector}
								toggleSelection={props.onBusinessSectorChange}
								checkboxItemsList={props.businessSectorList}
								selectedOptions={props.selectedBusinessSector}
								placeholderButtonLabel="Select Sector"
							/>
						</div>
						)}
					</div>

					<div className="col-md col-sm-6">
					{shouldHideFilters && (
						<div className="conv-zindex">
							{/* <Select
                          options={props.oppTitleNameList}
                            onChange={props.onOppTitleChange}
                            value={props.selectedOppTitle}
                          placeholder="Select Opp Title"
						  isClearable
                      /> */}
							<MultiSelectAll
								toggleAll={props.toggleAllBusinessCity}
								toggleSelection={props.onBusinessCityChange}
								checkboxItemsList={props.businessCityList}
								selectedOptions={props.selectedBusinessCity}
								placeholderButtonLabel="Select City"
							/>
						</div>
						)}
					</div>

					<div className="col-md col-sm-6 conv-zindex">
					{shouldHideFilters && (
						// <div className="">
						// 	<Checkbox
						// 		id={`checkbox2-completed`}
						// 		checked={props.confirmationChecked}
						// 		onChange={(e) => {
						// 			e.stopPropagation();
						// 			props.setConfirmationChecked(!props.confirmationChecked)
						// 			// updateConfirmationFlagData(row.original)
						// 			// props.getExternalPartnerServices()
						// 		}}
						// 		label={"Confirmation Received"}
						// 	// disabled={row.original.bConfirmation_tag}
						// 	></Checkbox>
						// </div>
						<div className="">
							<Select
								options={props.jpmcEligibleOption}
								onChange={props.onJpmcEligileOptionChange}
								value={props.selectedJpmcEligible}
								placeholder="Is JPMC Eligible"
								isClearable
							/>
						</div>
					)}
					</div>

					<div className="col-md col-sm-6 conv-zindex">
						{shouldVisibleNoShow && (
							<div className="conv-zindex">
								<Select
									options={props.noShowOption}
									onChange={props.onNoShowChange}
									value={props.selectedNoShow}
									placeholder="No Show"
									isClearable
								/>
							</div>
						)}
					</div>

					{/* <div>
                      <Button style={{
                          margin: 0,
                        //   margin: '0 5px',
                          height: '37px'
                      }}
                          onClick={() => props.onFilterSearchClick()}
                          // disabled={!props.selectedExtPartner}
                          className="con-btn-filled">Search</Button>
                  </div> */}

					{/* <button className="con-btn-filled ml-2 conv-pl50 conv-pr50 conv-text-decoration-u conv-font14 con-br0">
							Requests
						</button>
						<button className="notification con-btn-bordered-lg conv-font14 conv-pl15 conv-pr15 con-br0"
							onClick={() => { props.onTabChanged("Customer Feedback") }}>
							Customer Feedback
							<div className="notification-dot">{props.unReadFeedbackCount}</div>
						</button> */}

					{/* <div style={{
						position: 'absolute',
						right: "18px"
					}}>
						<button
							className="con-btn-bordered conv-float-right conv-font14 conv-pl15 conv-pr15 con-br0"
							onClick={props.onSearchClicked}>
							Search
						</button>
						<input
							type="text"
							className="conv-float-right form-control search-input1"
							placeholder="Search"
							onChange={props.onSearchInputChange}
							onKeyPress={(e) => {
								if (e.key === "Enter") {
									props.onSearchClicked();
								}
							}}
							autoComplete={false}
							value={props.searchTerm}
							name="searchTerm"
						/>

					</div> */}
				</div>

				<div className="row mt-3 mb-1">
					<div className="col-4">
						{/* <button className="con-btn-filled conv-pl15 conv-pr15 conv-font14"
							onClick={(e) => { props.handleViewFilterModal() }} >
							<img
								alt=""
								src={ic_filter}
								height={"15px"}
								width={"15px"}
								className="conv-mr10"
							/>
							Filter By
						</button> */}

						{shouldHideFilters && (
							<div className="" style={{display:"none"}}>
								<Checkbox
									id={`checkbox2-completed`}
									checked={props.confirmationChecked}
									onChange={(e) => {
										e.stopPropagation();
										props.setConfirmationChecked(!props.confirmationChecked)
										// updateConfirmationFlagData(row.original)
										// props.getExternalPartnerServices()
									}}
									label={"Confirmation Received"}
								// disabled={row.original.bConfirmation_tag}
								></Checkbox>
							</div>
						)}
					</div>
					<div className="col-4 conv-text-center">
						<button className="con-btn-filled conv-pl50 conv-pr50 conv-text-decoration-u conv-font14 con-br0">
							Requests
						</button>
						<button className="notification con-btn-bordered-lg conv-font14 conv-pl15 conv-pr15 con-br0"
							onClick={() => { props.onTabChanged("Customer Feedback") }}>
							Customer Feedback
							<div className="notification-dot">{props.unReadFeedbackCount}</div>
						</button>
					</div>
					<div className="col-4">
						<button
							className="con-btn-bordered conv-float-right conv-font14 conv-pl15 conv-pr15 con-br0"
							onClick={props.onSearchClicked}>
							Search
						</button>
						<input
							type="text"
							className="conv-float-right form-control search-input"
							placeholder="Search"
							onChange={props.onSearchInputChange}
							onKeyPress={(e) => {
								if (e.key === "Enter") {
									props.onSearchClicked();
								}
							}}
							autoComplete={false}
							value={props.searchTerm}
							name="searchTerm"
						/>

					</div>
				</div>
			</div>
			{
				props.FollowUpCount > 0 || props.AllFollowUpCount > 0 ?
					(
						<>
							<div style={{ clear: "both" }}></div>
							<div className="col-12 conv-mt25">
								<div className="row">
									<div className="col-6">
										<span
											className="spled-colored-label conv-text-decoration-u con-cursor-pointer conv-mr15"
											onClick={props.onFollowUpsCountClick}
										>{`Todays Follow Up Count ${props.FollowUpCount}`}
										</span>
										<span
											className="spled-colored-label conv-text-decoration-u con-cursor-pointer"
											onClick={props.onFollowUpsCountClick}
										>{`All Follow Up Count ${props.AllFollowUpCount}`}
										</span>
									</div>
								</div>
							</div>
						</>
					)
					:
					(
						""
					)

			}

			{/* Market Linkage Details Modal */}

			<Modal isOpen={marketLinkageModal}>
				<ModalContent className="business-details-modal-sp">
					<div className="modal-header" style={{
						backgroundColor: '#76287C',
						color: '#fff'
					}}>
						<span className="modal-title">Business Information</span>
						<img
							alt="close"
							id="Close"
							src={close_modal}
							className="close modal-close"
							onClick={openMarketLinkageModalisFalse}
						/>
					</div>

					<div className="modal-body">
						{/* <div className={`${loadingInModal && "set-opacity"}`}>
							{loadingInModal && <Spinner className="center-screen" />}
							<div className="row conv-pb10 conv-pt10">
								<div className="col-6">
									<span className="spled-info-title">Business Details</span>
								</div>
								<div className="col-6">
									<span className="spled-info-title">Catalogue Details</span>
								</div>
							</div>
							<div className="row conv-pb10 conv-pt10">
								<div className="col-3">
									<span className="spled-colored-label">Business Name</span>
								</div>
								<div className="col-3">
									<span className="spled-black-text">{userData?.sBusinessName || "NA"}</span>
								</div>

								<div className="col-3">
									<span className="spled-black-text">
									{
											catalogueLink ?
												<a href={catalogueLink} target="_blank">View Catalogue</a>
												:
												"Catalogue Unavailable"
										}
										</span>
								</div>
							</div>
							<div className="row conv-pb10 conv-pt10 align-items-center">
								<div className="col-3">
									<span className="spled-colored-label">Business Sector</span>
								</div>
								<div className="col-3">
									<span className="spled-black-text">
										{userData?.sBusinessSector ?
											userData.sBusinessSector :
											userData?.refBusinessSectorNew?.sSectorName
										}
									</span>
								</div>

								<div className="col-3">
									<button className="lpm-con-btn-filled" onClick={openTagModalisTrue}>View Tags</button>
								</div>
							</div>
							<div className="row conv-pb10 conv-pt10">
								<div className="col-3">
									<span className="spled-colored-label">Business City</span>
								</div>
								<div className="col-3">
									<span className="spled-black-text">{userData?.sBusinessCity || "NA"}</span>
								</div>
							</div>

							<div className="row conv-pb10 conv-pt15">
								<div className="col-6">
									<span className="spled-info-title">UMC opportunities availed before </span>
								</div>
							</div>

							<div>
								{
									umcTableData.length > 0 ?
										<div className="" style={{
											height: "35vh",
										}}>
											<div style={{ height: "100%", boxSizing: "border-box" }}>
												<div style={gridStyle} className="ag-theme-material">
													<AgGridReact
														ref={gridRef}
														rowData={umcTableData || []}
														columnDefs={columnDefs}
													>
													</AgGridReact>
												</div>
											</div>
										</div>
										:
										<div className="spled-colored-label">
											No Data Found
										</div>
								}
							</div>
						</div> */}
						<div className={`${loadingInModal && "set-opacity"}`}>
							{loadingInModal && <Spinner className="center-screen" />}
							<div className="row conv-pb10 conv-pt10">
								<div className="col-6">
									<span className="spled-info-title">Business Details</span>
									<div className="row mt-2">
										<div className="col-6">
											<span className="spled-colored-label">Business Name</span>
										</div>
										<div className="col-6">
											<span className="spled-black-text">{userData?.sBusinessName || "NA"}</span>
										</div>
									</div>

									<div className="row mt-1">
										<div className="col-6">
											<span className="spled-colored-label">Business Sector</span>
										</div>
										<div className="col-6">
											<span className="spled-black-text" style={{textTransform: 'uppercase'}}>
												{userData?.sBusinessSector ?
													userData.sBusinessSector :
													userData?.refBusinessSectorNew?.sSectorName
												}
											</span>
										</div>
									</div>

									<div className="row mt-1">
										<div className="col-6">
											<span className="spled-colored-label">Business City</span>
										</div>
										<div className="col-6">
											<span className="spled-black-text" style={{textTransform: 'uppercase'}}>{userData?.sBusinessCity || "NA"}</span>
										</div>
									</div>
								</div>

								<div className="col-6">
									<div>
										<div className="row">
											<div className="col-6 offset-5">
												<span className="spled-info-title">Catalogue Details</span>
											</div>
										</div>
										<div className="row mt-2">
											<div className="col-6 offset-5">
												<span className="spled-black-text">
													{
														catalogueLink ?
															<a href={catalogueLink} target="_blank">View Catalogue</a>
															:
															"Catalogue Unavailable"
													}
												</span>
											</div>
										</div>

										<div className="row mt-2">
											<div className="col-6 offset-5">
												<button className="lpm-con-btn-filled" onClick={openTagModalisTrue}>View Tags</button>
											</div>
										</div>

										<div className="row mt-2">
											<div className="col-6 offset-5">
												<span className="spled-black-text">
													{
														productLists?.length > 0 ?
															<u><a onClick={handleProductListModel} style={{ cursor: "pointer" }}>View Product List</a></u>
															:
															"Product List Not Available"
													}
												</span>
											</div>
										</div>

									</div>
								</div>
							</div>

							<div className="row conv-pb10 conv-pt15">
								<div className="col-6">
									<span className="spled-info-title">UMC opportunities availed before </span>
								</div>
							</div>

							<div>
								{
									umcTableData.length > 0 ?
										<div className="" style={{
											height: "200px",
										}}>
											<div style={{ height: "100%", boxSizing: "border-box" }}>
												<div style={gridStyle} className="ag-theme-material">
													<AgGridReact
														ref={gridRef}
														rowData={umcTableData || []}
														columnDefs={columnDefs}
													>
													</AgGridReact>
												</div>
											</div>
										</div>
										:
										<div className="spled-colored-label">
											No Data Found
										</div>
								}
							</div>
						</div>
					</div>
				</ModalContent>
			</Modal>

			{/* UMC Extra Data modal */}

			<Modal isOpen={umcAvailedDataModal}>
				<ModalContent className="medium-general-modal">
					<div className="modal-header" style={{
						backgroundColor: '#76287C',
						color: '#fff'
					}}>
						<span className="modal-title">Availed Details</span>
						<img
							alt="close"
							id="Close"
							src={close_modal}
							className="close modal-close"
							onClick={openUmcAvailedDataModalIsFalse}
						/>
					</div>

					<div className="modal-body">
					<div>
								{
									umcAvailedData.length > 0 ?
										<div className="" style={{
											height: "300px",
										}}>
											<div style={{ height: "100%", boxSizing: "border-box" }}>
												<div style={gridStyle} className="ag-theme-material">
													<AgGridReact
														ref={gridRef}
														rowData={umcAvailedData || []}
														columnDefs={columnDefs1}
													>
													</AgGridReact>
												</div>
											</div>
										</div>
										:
										<div className="spled-colored-label">
											No Data Found
										</div>
								}
							</div>
					</div>
				</ModalContent>
			</Modal>

			<Modal isOpen={tagModal}>
				<ModalContent className="general-modal">
					<div className="modal-header" style={{
						backgroundColor: '#76287C',
						color: '#fff'
					}}>
						<span className="modal-title">Tags </span>
						<img
							alt="close"
							id="Close"
							src={close_modal}
							className="close modal-close"
							onClick={openTagModalisFalse}
						/>
					</div>

					<div className="modal-body">
						<div className={`${TagModalLoading && "set-opacity"}`}>
							{TagModalLoading && <Spinner className="top" />}

							<div className="row conv-pt10">
								<div className="col-12">
									<span className="spled-info-title">Assigned Tags</span>
								</div>
							</div>

							<div className="selected-tags-container" style={styles.selectedTagsContainer}>
								{
									selectedOptions.length > 0 ?
										selectedOptions.map((option) => (
											<div className="selected-tag" key={option.value} style={styles.selectedTag}>
												{option.label}
											</div>
										))
										:
										<div className="spled-colored-label">
											No Tags Found
										</div>
								}
							</div>
							<div className="row conv-pt10">
								<div className="col-12">
									<span className="spled-info-title">Add Tags</span>
								</div>
							</div>
							<div className="row mt-2">
								<div className="col-6 spled-container w-100">
									<ReactMultiSelectCheckboxes
										options={tagsDropDownList}
										value={selectedOptions}
										onChange={handleChange}
										placeholderButtonLabel="Select..."
										isClearable
									/>
								</div>
								<div className="col-4 spled-container w-100">
									<Button className="esp-inline-button" onClick={onSaveTags}>Save</Button>
								</div>
							</div>
						</div>
					</div>
				</ModalContent>
			</Modal>

			{/* Update Price Modal */}

			<Modal isOpen={updatePriceModal}>
				<ModalContent className="general-modal">
					<div className="modal-header" style={{
						backgroundColor: '#76287C',
						color: '#fff'
					}}>
						<span className="modal-title">Update Price</span>
						<img
							alt="close"
							id="Close"
							src={close_modal}
							className="close modal-close"
							onClick={openPriceUpdateModalisFalse}
						/>
					</div>

					<div className="modal-body">
						<div className={`${loading && "set-opacity"}`}>
							{loading && <Spinner className="top" />}
							<div className="row">
								<div className="col m-2">
									<span className="spled-colored-label">Service Price</span> <span className="spled-black-text">: {originalAmount}</span>
								</div>
							</div>
							<div className="row mt-2">
								<div className="col-12 w-100">
									<input type="number" placeholder="New Service Amount (Including GST)" style={{
										width: "100%",
										height: '45px'
									}}
										onKeyDown={(e) => {
											const invalidChars = ['=', '-', '+', 'e'];
											if (invalidChars.includes(e.key)) {
												e.preventDefault();
											}
										}}
										value={updatedAmount}
										onChange={(e) => setUpdatedAmount(e.target.value)}
									/>

								</div>
							</div>
							<div className="row m-2">
								<div className="offset-3 col-6">
									<Button onClick={updatePriceButton}>Update Price</Button>
								</div>
							</div>
						</div>
					</div>
				</ModalContent>
			</Modal>


			{/* Apply Discount Modal */}

			<Modal isOpen={applyDiscountModal} style={{ zIndex: 1 }}>
				<ModalContent className="general-modal">
					<div className="modal-header" style={{
						backgroundColor: '#76287C',
						color: '#fff'
					}}>
						<span className="modal-title">Apply Discount</span>
						<img
							alt="close"
							id="Close"
							src={close_modal}
							className="close modal-close"
							onClick={openApplyDiscountModalisFalse}
						/>
					</div>

					<div className="modal-body">
						<div className="row">
							<div className="col m-2">
								<span className="spled-colored-label">Original Service Amount</span> <span className="spled-black-text">: {basePrice.toFixed(2)}</span>
							</div>
						</div>
						<div className="row mt-2">
							<div className="col-12 w-100">
								<input type="number" placeholder="Enter Discount Amount (In Figures)" style={{
									width: "100%",
									height: '45px'
								}}
									min="0"
									onKeyDown={(e) => {
										const invalidChars = ['=', '-', '+', 'e'];
										if (invalidChars.includes(e.key)) {
											e.preventDefault();
										}
									}}
									value={discountAmount}
									onChange={(e) => setDiscountAmount(e.target.value)} />
							</div>
						</div>
						<div className="row m-2">
							<div className="offset-3 col-6">
								<Button onClick={applyDiscountBtn}>Apply Discount</Button>
							</div>
						</div>
					</div>
				</ModalContent>
			</Modal>

			{/* Confirmation Modal */}

			<Modal isOpen={confirmationModal} style={{ zIndex: 1 }}>
				<ModalContent className="confirmation-modal-small">
					<div className="modal-header" style={{
						backgroundColor: '#76287C',
						color: '#fff'
					}}>
						<span className="modal-title">Confirm</span>
						<img
							alt="close"
							id="Close"
							src={close_modal}
							className="close modal-close"
							onClick={openConfirmationModalisFalse}
						/>
					</div>

					<div className="modal-body">
						Are you sure you want to perform this action? Discount once applied can not be removed.
						<div className="row">
							<div className="col-12 d-flex align-items-center" style={{
								justifyContent: 'flex-end'
							}}>
								<button
									type="button"
									className="my-services-model-submit-btn conv-mr25"
									onClick={confirmDiscount}>
									Yes
								</button>
								<button
									type="button"
									className="my-services-model-cancel-btn conv-mr25"
									onClick={() => {
										openConfirmationModalisFalse()
										openApplyDiscountModalisFalse()
									}}>
									No
								</button>
							</div>

						</div>
					</div>
				</ModalContent>
			</Modal>


			<Modal isOpen={confirmUpdatePriceModal} style={{ zIndex: 1 }}>
				<ModalContent className="confirmation-modal-small">
					<div className="modal-header" style={{
						backgroundColor: '#76287C',
						color: '#fff'
					}}>
						<span className="modal-title">Confirm</span>
						<img
							alt="close"
							id="Close"
							src={close_modal}
							className="close modal-close"
							onClick={openConfirmUpdateModalisFalse}
						/>
					</div>

					<div className="modal-body">
						Are you sure you want to perform this action? Price set to 0(zero) will move this service to SPM.
						<div className="row">
							<div className="col-12 d-flex align-items-center" style={{
								justifyContent: 'flex-end'
							}}>
								<button
									type="button"
									className="my-services-model-submit-btn conv-mr25"
									onClick={confirmUpdateModalClick}
								>
									Yes
								</button>
								<button
									type="button"
									className="my-services-model-cancel-btn conv-mr25"
									onClick={() => {
										openConfirmUpdateModalisFalse()
									}}
								>
									No
								</button>
							</div>

						</div>
					</div>
				</ModalContent>
			</Modal>


			<div className={`col-12 service-partner spled-container ${props.FollowUpCount > 0 || props.AllFollowUpCount > 0 ? ' conv-mt5' : ' conv-mt10'}`}>
				{/*props.showTable?(*/<ReactTableFixedColumns
					//ref={reactTable}
					minRows={0}
					data={props.data || []}
					columns={columns}
					manual
					defaultPage={props.page}
					pages={props.pages}
					page={props.page}
					isTotalRecords = {true}
					pageSize={props.pageSize}
					totalRecords={props.totalRecords}
					sortable={false}
					defaultPageSize={10}
					showPagination={true}
					pageSizeOptions={[10, 20, 30]}
					onFetchData={(state, instance) => {
						props.onFetchServiceRequests(instance, false);
						//instance.state.pages = props.pages;
					}}
					onExpandedChange={(newExpanded, index, event, row) => {
						if (newExpanded[index[0]] === false) {
							newExpanded = {}
						} else {
							Object.keys(newExpanded).map(k => {
								newExpanded[k] = parseInt(k) === index[0] ? {} : false
							})
						}
						// setExpanded(newExpanded)
						// verifiedStatus(row.original)
					}}
					onPageSizeChange={props.onPageSizeOptionChange}
					getTdProps={(state, rowInfo, column, instance) => {
						if (rowInfo && rowInfo.original) {
							const isCouponApplied = rowInfo.original.sCouponCode === "JPMCCOMPLAINCEGST100" && rowInfo.original.fDiscountAmount === rowInfo.original.fAmountFull;
							return {
								style: {
									backgroundColor: isCouponApplied ? '#FFC1CC' : ''
								}
							};
						}
						return {};
					}}
					expanded={props.ExpandedChange}
					getTrProps={(state, rowInfo, column, instance, row, expanded) => {

						if (typeof rowInfo !== "undefined") {
							return {
								onClick: e => {
									const expanded = {};
									expanded[rowInfo.viewIndex] = props.ExpandedChange[rowInfo.viewIndex] ? false : true;
									props.setExpandedChange(expanded);
								},
								/*style: {
									backgroundColor: props.ExpandedChange[rowInfo.viewIndex]&&props.ExpandedChange[rowInfo.viewIndex] === true ? '#F4DFF4' : '',
								},*/
								className: `${props.ExpandedChange[rowInfo.viewIndex] && props.ExpandedChange[rowInfo.viewIndex] === true ? 'selected' : ''} 
								${" "}
								${rowInfo.original.bNeedToTalkToSP ? 'text-color-red' : ''}`,
							}
						}
						else {
							return {
								onClick: e => {
									const expanded = {};
									expanded[rowInfo.viewIndex] = props.ExpandedChange[rowInfo.viewIndex] ? false : true;
									props.setExpandedChange(expanded);
								},
								className: `${rowInfo.original.bNeedToTalkToSP ? 'text-color-red' : ''}`,
							}
						}
					}}

					SubComponent={row => {
						setResourceId(row.original.nResourceInstanceId)
						setOriginalAmount(row.original.fAmountFull)
						setOriginalDiscount(row.original.fDiscountAmount)
						props.checkNotes(row.original.nResourceInstanceId, props.serviceNameListForFilter)
						return (
							<div className="row conv-pt20 conv-pl15 conv-bg-f8f8f8 conv-mr0"
								onClick={(e) => {
									let val = row.original;
									// verifiedStatus(val)	
								}}
							>
								<div className="col-6">
									<span className="spled-info-title">Information</span>
									<div className="row">
										<div className="col-5">
											<div className="row conv-pb10 conv-pt10">
												<div className="col-8">
													<span className="spled-colored-label">Service ID</span>
												</div>
												<div className="col-4">
													<span className="spled-black-text">{row.original.nResourceInstanceId}</span>
												</div>
											</div>
											<div className="row conv-pb10 conv-pt10">
												<div className="col-8">
													<span className="spled-colored-label">Request a Call Back</span>
												</div>
												<div className="col-4">
													<span className="spled-black-text">{row.original.bRequestedCallBack ? "Yes" : "No"}</span>
												</div>
											</div>
											<div className="row conv-pb10 conv-pt10">
												<div className="col-8">
													<span className="spled-colored-label">Need to talk to SP</span>
												</div>
												<div className={`col-4  ${props.selectedServiceForEdit && props.selectedServiceForEdit.nResourceInstanceId && props.selectedServiceForEdit.nResourceInstanceId === row.original.nResourceInstanceId && row.original.bNeedToTalkToSP ? "conv-pl5 conv-pr5" : ""} `}>
													{
														props.selectedServiceForEdit && props.selectedServiceForEdit.nResourceInstanceId && props.selectedServiceForEdit.nResourceInstanceId === row.original.nResourceInstanceId && row.original.bNeedToTalkToSP ?
															(
																<>
																	{
																		<Select
																			placeholder={"Select"}
																			options={props.needToTalkToSPOptions}
																			onChange={(e) => props.onNeedToTalkToSPOptionChange(e, row.original)}
																			value={getSelectedItem(props.needToTalkToSPOptions, props.selectedServiceForEdit.custbNeedToTalkToSP)}
																			className='react-select-container'
																			classNamePrefix="react-select"
																			theme={theme => ({
																				...theme,
																				colors: {
																					...theme.colors,
																					primary: '#76287C',
																					primary25: '#F4DFF4',
																				},
																			})}
																			isDisabled={row.original.custrefSRState == "Cancelled" || row.original.custrefSRState == "Delivered"}
																		></Select>
																	}
																</>
															) :
															(
																<span className="spled-black-text">{row.original.bNeedToTalkToSP ? "Yes" : "No"}</span>
															)
													}

												</div>
											</div>
											<div className="row conv-pb10 conv-pt10">
												<div className="col-8">
													<span className="spled-colored-label">Request By</span>
												</div>
												<div className="col-4">
													<span className="spled-black-text">{row.original.sExternalHHEmail ? "EHH" : "User"}</span>
												</div>
											</div>
											<div className="row conv-pb10 conv-pt10">
												<div className="col-8">
													<span className="spled-colored-label">Language Barrier</span>
												</div>
												<div className="col-4">
													<span className="spled-black-text">{row.original.bStayEngagedWithEhh ? "Yes" : "No"}</span>
												</div>
											</div>
										</div>
										<div className="col-7">
											{/* <div className="row conv-pb10 conv-pt10">
												<div className="col-8">
													<span className="spled-colored-label">Service Cost After Discount (Inclusive of Taxes):</span>
												</div>
												<div className="col-4">
													<span className="spled-black-text" style={{ wordBreak: "break-all", marginLeft: "15px" }}>
														{
															row.original.fAmountFull
																&& row.original.fAmountFull != 0 ?
																row.original.fAmountFull :
																"NA"
														}
													</span>
												</div>
											</div> */}
											<div className="row conv-pb10 conv-pt10">
												<div className="col-8">
													<span className="spled-colored-label">Coupon Applied</span>
												</div>
												<div className="col-4">
													<span className="spled-black-text" style={{ wordBreak: "break-all", marginLeft: "15px" }}>
														{row.original.bCouponApplied ?
															(
																<>
																	{row.original.dtCouponExpiryDate ?
																		(
																			<>
																				{
																					new Date(row.original.dtCouponExpiryDate) < new Date() ?
																						(
																							<>
																								<span style={{ color: "red" }}>Yes</span>
																								<span title={getCouponExpiryDate(row.original)}>
																									<Info style={{ marginLeft: "10px", width: "15px" }} />
																								</span>
																							</>
																						) :
																						(
																							<>
																								<span style={{ color: "green" }}>Yes</span>
																								<span title={getCouponExpiryDate(row.original)}>
																									<Info style={{ marginLeft: "10px", width: "15px" }} />
																								</span>
																							</>
																						)
																				}
																			</>
																		) :
																		(
																			<>
																				<span>Yes</span>
																				<span title={"Coupon Expiry Date: Not Available"}>
																					<Info style={{ marginLeft: "10px", width: "15px" }} />
																				</span>
																			</>
																		)}
																</>
															) :
															(
																"No"
															)}
													</span>
												</div>
											</div>

											{
												row.original.sCouponCode &&
												<div className="row conv-pb10 conv-pt10">
													<div className="col-4">
														<span className="spled-colored-label">Coupon Code</span>
													</div>
													<div className="col-8">
														<span className="spled-black-text" style={{ wordBreak: "break-all", marginLeft: "15px" }}>
															{row.original.sCouponCode ?
																(
																	<>
																		{row.original.dtCouponExpiryDate ?
																			(
																				<>
																					{
																						new Date(row.original.dtCouponExpiryDate) < new Date() ?
																							(<span style={{ color: "red" }}>{row.original.sCouponCode}</span>) :
																							(<span style={{ color: "green" }}>{row.original.sCouponCode}</span>)
																					}
																				</>
																			) :
																			(
																				<span>{row.original.sCouponCode}</span>
																			)}
																	</>
																) :
																(
																	"NA"
																)}
														</span>
													</div>
												</div>
											}



											<div className="row conv-pb10 conv-pt10">
												<div className="col-8">
													<span className="spled-colored-label">Discount Amount</span>
												</div>
												<div className="col-4">
													<span className="spled-black-text" style={{ wordBreak: "break-all", marginLeft: "15px" }}>
														{/* {row.original.fDiscountAmount ?
															(
																<>
																	{row.original.dtCouponExpiryDate ?
																		(
																			<>
																				{
																					new Date(row.original.dtCouponExpiryDate) < new Date() ?
																						(<span style={{ color: "red" }}>{Number.isInteger(row.original.fDiscountAmount) ? row.original.fDiscountAmount : Number(row.original.fDiscountAmount).toFixed(2)}</span>) :
																						(<span style={{ color: "green" }}>{Number.isInteger(row.original.fDiscountAmount) ? row.original.fDiscountAmount : Number(row.original.fDiscountAmount).toFixed(2)}</span>)
																				}
																			</>
																		) :
																		(
																			<span>{Number.isInteger(row.original.fDiscountAmount) ? row.original.fDiscountAmount : Number(row.original.fDiscountAmount).toFixed(2)}</span>
																		)}
																</>
															) :
															(
																"NA"
															)} */}
													</span>
												</div>
											</div>

											<div className="row conv-pb10 conv-pt10">
												<div className="col-8">
													<span className="spled-colored-label">Service Cost After Discount (Inclusive of Taxes):</span>
												</div>
												<div className="col-4">
													<span className="spled-black-text" style={{ wordBreak: "break-all", marginLeft: "15px" }}>
														{
															row.original.fDiscountAmount
																?
																(row.original.fDiscountAmount - row.original.fAmountFirst) === 0 ?
																	"0"
																	:
																	row.original.nPackageInstanceId
																		?
																		(
																			<>
																				{row.original.fDiscountAmount > row.original.fPackageOfferAmount ?
																					<span>0</span>
																					:
																				row.original.dtCouponExpiryDate ?
																					(
																						<>
																							{/* {
																								new Date(row.original.dtCouponExpiryDate) < new Date() ?
																									(<span style={{ color: "red" }}>{row.original.fPackageOfferAmount - row.original.fDiscountAmount}</span>) :
																									(<span style={{ color: "green" }}>{row.original.fPackageOfferAmount - row.original.fDiscountAmount}</span>)
																							} */}
																							{
																								new Date(row.original.dtCouponExpiryDate) < new Date() ?
																									(<span style={{ color: "red" }}>{getServiceCostAmountAfterDiscount(row.original.fPackageOfferAmount, row.original.fDiscountAmount, row?.original?.fdeAsraPlatformCharges, row?.original?.fPackageOfferGST)}</span>) :
																									(<span style={{ color: "green" }}>{getServiceCostAmountAfterDiscount(row.original.fPackageOfferAmount, row.original.fDiscountAmount, row?.original?.fdeAsraPlatformCharges, row?.original?.fPackageOfferGST)}</span>)
																							}
																						</>
																					) :
																					(
																						// <span>{row.original.fPackageOfferAmount - row.original.fDiscountAmount}</span>
																						<span>{getServiceCostAmountAfterDiscount(row.original.fPackageOfferAmount, row.original.fDiscountAmount, row?.original?.fdeAsraPlatformCharges, row?.original?.fPackageOfferGST)}</span>

																					)}
																			</>
																		)
																		:
																		(
																			<>
																				{/* {
																					row.original.sPaymentMode === "2_Step_Payment" ?
																						(
																							<span>{row.original.fAmountFirst}</span>
																						)
																						:
																						row.original.dtCouponExpiryDate ?
																							(
																								<>
																									{
																										new Date(row.original.dtCouponExpiryDate) < new Date() ?
																											(<span style={{ color: "red" }}>{Math.round(((row.original.fAmountFirst * (100 / 118)) - row.original.fDiscountAmount) * (118 / 100))}</span>) :
																											(<span style={{ color: "green" }}>{Math.round(((row.original.fAmountFirst * (100 / 118)) - row.original.fDiscountAmount) * (118 / 100))}</span>)
																									}
																								</>
																							) :
																							(
																								<span>{row.original.fAmountFirst - row.original.fDiscountAmount}</span>
																							)
																				} */}
																				{
																					row.original.sPaymentMode === "2_Step_Payment" ?
																						(
																							// <span>{row.original.fAmountFirst}</span>
																							<>
																							{row.original.fDiscountAmount > row.original.fAmountFirst ?
																								<>
		
																									{
																										new Date(row.original.dtCouponExpiryDate) < new Date() ?
																											(<span style={{ color: "red" }}>{getServiceCostAmountAfterDiscount(row.original.fAmountFull, row.original.fDiscountAmount, row?.original?.fdeAsraPlatformCharges, row?.original?.fPackageOfferGST)}</span>) :
																											(<span style={{ color: "green" }}>{getServiceCostAmountAfterDiscount(row.original.fAmountFull, row.original.fDiscountAmount, row?.original?.fdeAsraPlatformCharges, row?.original?.fPackageOfferGST)}</span>)
																									}
																								</>
																								:
																								<span>{row.original.fAmountFirst}</span>
																							}
																						</>
																						)
																						:
																						row.original.dtCouponExpiryDate ?
																							(
																								<>
																									{
																										new Date(row.original.dtCouponExpiryDate) < new Date() ?
																											// (<span style={{ color: "red" }}>{Math.round(((row.original.fAmountFirst * (100 / 118)) - row.original.fDiscountAmount) * (118 / 100))}</span>) :
																											// (<span style={{ color: "green" }}>{Math.round(((row.original.fAmountFirst * (100 / 118)) - row.original.fDiscountAmount) * (118 / 100))}</span>)
																											(<span style={{ color: "red" }}>{getServiceCostAmountAfterDiscount(row.original.fAmountFirst,row.original.fDiscountAmount, row?.original?.fdeAsraPlatformCharges, row?.original?.fPackageOfferGST)}</span>) :
																											(<span style={{ color: "green" }}>{getServiceCostAmountAfterDiscount(row.original.fAmountFirst,row.original.fDiscountAmount, row?.original?.fdeAsraPlatformCharges, row?.original?.fPackageOfferGST)}</span>)
																											// (<span style={{ color: "red" }}>{Number.isInteger(row.original.fAmountFirst - row.original.fDiscountAmount) ? row.original.fAmountFirst - row.original.fDiscountAmount : Number(row.original.fAmountFirst - row.original.fDiscountAmount).toFixed(2)}</span>) :
																											// (<span style={{ color: "green" }}>{Number.isInteger(row.original.fAmountFirst - row.original.fDiscountAmount) ? row.original.fAmountFirst - row.original.fDiscountAmount : Number(row.original.fAmountFirst - row.original.fDiscountAmount).toFixed(2)}</span>)
																									}
																								</>
																							) :
																							(
																								<span>{getServiceCostAmountAfterDiscount(row.original.fAmountFirst, row.original.fDiscountAmount, row?.original?.fdeAsraPlatformCharges, row?.original?.fPackageOfferGST)}</span>
																							)
																				}
																			</>
																		)
																:
																row.original.fAmountFirst != 0
																	?
																	row.original.fAmountFirst
																	:
																	"NA"
														}
													</span>
												</div>
											</div>

											{/* row.original.dtCouponExpiryDate ?
																(
																	<>
																		{
																			new Date(row.original.dtCouponExpiryDate) < new Date() ?
																				(<span style={{ color: "red" }}>{row.original.fPackageOfferAmount - row.original.fDiscountAmount}</span>) :
																				(<span style={{ color: "green" }}>{row.original.fPackageOfferAmount - row.original.fDiscountAmount}</span>)
																		}
																	</>
																)
																:
																row.original.fPackageOfferAmount - row.original.fDiscountAmount */}

											<div className="row conv-pb10 conv-pt10">
												<div className="col-2">
													<span className="spled-colored-label">Facilitator</span>
												</div>
												<div className="col-10">
													<span className="spled-black-text" style={{ wordBreak: "break-all", marginLeft: "15px" }}>
														{
															row.original.existing_service_facilitator ?
																row.original.existing_service_facilitator.email :
																row.original.refFacilitator ?
																	row.original.refFacilitator.email :
																	"NA"
														}
													</span>
												</div>
											</div>

											{/* Verification Status Implementation */}
											{/* {
												row.original.sServiceCode === "DEPRELISTING"
													?
													<div className="row conv-pb10 conv-pt10">
											<div className="col-3">
													<span className="spled-colored-label">Verified</span>
												</div>
												<div className="col-9">
													<span className="spled-black-text">{verified ? verified : "No"}</span>
												</div>
													</div>
													:
													""
											} */}
											<div className="row conv-pb10 conv-pt10">
												<div className="col-6">
													<span className="spled-colored-label">EHH Information</span>
												</div>
											</div>
											<div className="row conv-pb10 conv-pt10">
												<div className="col-12">
													<span className="spled-black-text">{row.original.sEhhName ? row.original.sEhhName : "NA"}</span>
												</div>
												<div className="col-12">
													<span className="spled-black-text">{row.original.sExternalHHEmail ? row.original.sExternalHHEmail : "NA"}</span>
												</div>
												<div className="col-12">
													<span className="spled-black-text">{row.original.sEhhContactNumber ? row.original.sEhhContactNumber : "NA"}</span>
												</div>
											</div>
										</div>
									</div>
								</div>
								<div className="col-6">
									<div className="row">
										<div className="col-7">
											<span className="spled-info-title">Service Progression Details</span>
											<div className="row conv-pb10 conv-pt10">
												<div className="col-4 conv-pr0">
													<span className="spled-colored-label">Call Connected</span>
												</div>
												<div className="col-8">
													{
														props.selectedServiceForEdit && props.selectedServiceForEdit.nResourceInstanceId && props.selectedServiceForEdit.nResourceInstanceId === row.original.nResourceInstanceId ?
															(
																<>
																	{
																		<Select
																			placeholder={"Select call status"}
																			options={props.callStatusOptions}
																			onChange={(e) => props.onCallStatusOptionChange(e, row.original)}
																			value={getSelectedItem(props.callStatusOptions, props.selectedServiceForEdit.custsCallStatus)}
																			className='react-select-container'
																			classNamePrefix="react-select"
																			theme={theme => ({
																				...theme,
																				colors: {
																					...theme.colors,
																					primary: '#76287C',
																					primary25: '#F4DFF4',
																				},
																			})}
																			isDisabled={row.original.custrefSRState == "Cancelled" || row.original.custrefSRState == "Delivered"}
																		></Select>
																	}
																</>
															) :
															(
																<span className="spled-black-text">{getSelectedItemLable(props.callStatusOptions, row.original.sCallStatus) || ""}</span>
															)
													}

												</div>
											</div>
											<div className="row conv-pb10 conv-pt10">
												<div className="col-4 conv-pr0">
													<span className="spled-colored-label">Service Status</span>
												</div>
												<div className="col-8">
													{
														props.selectedServiceForEdit && props.selectedServiceForEdit.nResourceInstanceId && props.selectedServiceForEdit.nResourceInstanceId === row.original.nResourceInstanceId ?
															(
																<Select
																	maxMenuHeight={300}
																	minMenuHeight={300}
																	placeholder={"Select service status"}
																	options={props.ServiceRequestsStatesOptions}
																	onChange={(e) => {
																		// if(e.value === "Refunded"){
																		// 	props.toggleRefundModal()
																		// }
																		props.onServiceRequestsStateChange(e, row.original)
																	}}
																	// value={getSelectedItem(props.ServiceRequestsStatesOptions, props.selectedServiceForEdit.custrefSRState)}
																	value={getSelectedItem(
																		props.ServiceRequestsStatesOptions,
																		props.selectedServiceForEdit.custrefSRState === "Info & Docs Received"
																		  ? "Awaiting for information/Documents"
																		  : props.selectedServiceForEdit.custrefSRState
																	  )}
																	className='react-select-container'
																	classNamePrefix="react-select"
																	theme={theme => ({
																		...theme,
																		colors: {
																			...theme.colors,
																			primary: '#76287C',
																			primary25: '#F4DFF4',
																		},
																	})}
																	menuPortalTarget={document.body}
																	menuPosition={'fixed'}
																	isDisabled={row.original.custrefSRState == "Cancelled" || row.original.custrefSRState == "Delivered" || props.isForAdmin}
																></Select>
															) :
															(
																<span className="spled-black-text" style={{ wordBreak: "break-all" }}>
																	{
																		row.original.custrefSRState == "Cancelled" || row.original.custrefSRState == "Delivered" ?
																			(
																				row.original.custrefSRState
																			) :
																			(

																				row.original.sPaymentReceiver == "Partner" ?
																					(
																						row.original?.refExternalServicePartner === "Mr. Sudhir Gijare" ?

																							(
																								row.original.custrefSRState == "Prepared" ||
																									row.original.custrefSRState == "Ready For Progression" ?
																									"Willing to Pay" :
																									row.original.custrefSRState == "Partial/ Full Payment Pending" ?
																										"Willing to Pay" :
																										row.original.custrefSRState == "Payment Confirmed By Partner" ?
																											"Payment Received" :
																											row.original.custrefSRState
																							) :
											 												row.original.custrefSRState == "Prepared" ? row.original?.nPackageInstanceId ? "Willing to Pay" : "Quotation Sent" :
																							row.original.custrefSRState == "Ready For Progression" ?
																							// "Willing to Pay" :
																							"Payment Received" :
																							row.original.custrefSRState == "Partial/ Full Payment Pending" ?
																								"Willing to Pay" :
																								row.original.custrefSRState == "Payment Confirmed By Partner" ?
																									"Payment Received" :
																									row.original.custrefSRState === "Info & Docs Received"
																										? "Awaiting for information/Documents"
																										: row.original.custrefSRState
																					) :
																					// row.original.custrefSRState == "Prepared" || row.original.custrefSRState == "Partial/ Full Payment Pending" ?
																					// 	"Willing to Pay" :
																					// 	row.original.custrefSRState == "Payment Received" ||
																					// 		row.original.custrefSRState == "Ready For Progression" ?
																					// 		"Payment Received" :
																					// 		row.original.custrefSRState === "Info & Docs Received"
																					// 			? "Awaiting for information/Documents"
																					// 			: row.original.custrefSRState
																					row.original.custrefSRState == "Prepared" || row.original.custrefSRState == "Partial/ Full Payment Pending" ?
																						"Willing to Pay" :
																						row.original.custrefSRState == "Payment Received" ||
																							row.original.custrefSRState == "Ready For Progression" ?
																							"Payment Received" :
																							row.original.custrefSRState
																			)
																	}
																</span>
															)
													}
												</div>
											</div>
											{
												getShowdePrenuersColumn() ?
													(
														<div className="row conv-pb10 conv-pt10">
															<div className="col-4 conv-pr0">
																<span className="spled-colored-label">dePreneur Listing</span>
															</div>
															<div className="col-8">
																<button
																	type="button"
																	className="con-btn-filled conv-mr15"
																	onClick={(e) => props.handleViewdePreneurDetailsModal(row.original)}
																>
																	Manage
																</button>
															</div>
														</div>
													)
													:
													("")
											}

											{
												(row.original.custrefSRState === "Requested" || row.original.custrefSRState === "Eligible") &&
												row.original.sMode === "FIXED_DeAsraDriven" &&
												!row.original.bCouponApplied &&
												(
													<div className="row conv-pb10 conv-pt10">
														<div className="col-8">
															<button
																type="button"
																className="con-btn-filled conv-mr15"
																onClick={openApplyDiscountModalisTrue}
															>
																Apply Discount
															</button>
														</div>
													</div>
												)
											}

											<div className="row conv-pb10 conv-pt10">
												<div className="col-4 conv-pr0">
													<span className="spled-colored-label">Cancellation Reason</span>
												</div>
												<div className="col-8">
													{
														props.selectedServiceForEdit && props.selectedServiceForEdit.nResourceInstanceId && props.selectedServiceForEdit.nResourceInstanceId === row.original.nResourceInstanceId ?
															(
																<>
																	{
																		<Select
																			minMenuHeight={300}
																			maxMenuHeight={300}
																			placeholder={"Select Reason"}
																			options={props.cancellationReasonDropdownOptions}
																			onChange={(e) => props.onCancellationReasonChange(e, row.original)}
																			isClearable
																			value={getSelectedItem(props.cancellationReasonDropdownOptions, props.selectedServiceForEdit.custsSRCancellationReason)}
																			className='react-select-container'
																			classNamePrefix="react-select"
																			theme={theme => ({
																				...theme,
																				colors: {
																					...theme.colors,
																					primary: '#76287C',
																					primary25: '#F4DFF4',
																				},
																			})}
																			styles={{
																				menuPortal: provided => ({ ...provided, zIndex: 9999 }),
																				menu: provided => ({ ...provided, zIndex: 9999 })
																			}}
																			menuPortalTarget={document.body}
																			menuPosition={'fixed'}
																			isDisabled={props.selectedServiceForEdit.custrefSRState != "Cancelled" || row.original.custrefSRState == "Cancelled" || row.original.custrefSRState == "Delivered" ? true : false}
																		></Select>
																	}
																</>
															) :
															(
																<span className="spled-black-text" style={{ wordBreak: "break-all" }}>
																	{
																		row.original.custsSRCancellationReason ?
																			row.original.custsSRCancellationReason === "Other" ?
																				row.original.custssSRCancellationReasonOtherDescription :
																				row.original.custsSRCancellationReason : ""
																	}
																</span>
															)
													}
												</div>
											</div>

											<div className="row conv-pb10 conv-pt10">
												<div className="col-4 conv-pr0">
													<span className="spled-colored-label">Payment Link</span>
												</div>
												<div className="col-8">
													{
														row.original.urlPayment && row.original?.refCurrentState?.sServiceState !== "Full Payment Received" && row.original?.refCurrentState?.sServiceState !== "Cancelled" && row.original?.refCurrentState?.sServiceState !== "Delivered" ? (
															<>
																<img
																	alt="copy"
																	title="Copy Payment Link"
																	src={copysvg}
																	height={"20px"}
																	width={"16px"}
																	className="con-cursor-pointer conv-mr13 conv-ml10"
																	onClick={(e) => {
																		e.preventDefault();
																		
																		if (row.original.urlPayment) {
																			copyToClipboard(row.original.urlPayment);
																			toast(`Payment Link Copied!`, {
																				autoClose: 5000,
																				type: toast.TYPE.SUCCESS,
																			});
																		} else {
																			toast(`No payment link found`, {
																				autoClose: 5000,
																				type: toast.TYPE.ERROR, // Use ERROR instead of SUCCESS
																			});
																		}
																	}}
																	
																/> 
																{/* <small>(copy payment link)</small> */}
															</>
														) : ""
													}
												</div>
											</div>

											{shouldVisibleNoShow &&
												<div className="row conv-pb10 conv-pt10">
													<div className="col-4 conv-pr0">
														<span className="spled-colored-label">No Show</span>
													</div>
													<div className="col-8">

														<label className={`checkbox-container ${props.selectedNoShowEligible ? 'checkbox-disabled' : ''}`}>
															<input type="checkbox"
																checked={props.selectedNoShowEligible}
																disabled={props.selectedNoShowEligible}
																onClick={(e) => {
																	props.handleNoShow(e, row.original)
																}}
															/>
															<span className="table-checkbox"></span>
														</label>
													</div>
												</div>
											}

											<div className="row conv-pb10 conv-pt10">
												<div className="col-4 conv-pr0">
													<span className="spled-colored-label">
															{
															// row.original.sMode === "DYNAMIC_DeAsraDriven"
															(row.original?.sMode === "DYNAMIC_DeAsraDriven" ||
                                                        (
                                                            (row.original?.sPackageOfferTitle === 'Long Term Engagement Package' || row.original?.sPackageOfferTitle === 'Long Term Engagement Package1' )
															&&
                                                            (
                                                                row.original?.refExternalServicePartner === 'Mr. Sudhir Gijare' ||
                                                                row.original?.ext_sp_org === 'Mr. Sudhir Gijare'
                                                            )
                                                        ))
																// && row.original.fAmountFull === 0
																&& (row.original.refSRState === "Eligible"
																	|| row.original.refSRState === "Requested"
																	|| row.original.refSRState === "Partial/ Full Payment Pending" && !row.original.urlPayment
																)
																?

																<button
																	type="button"
																	className="my-services-model-cancel-btn conv-mr25"
																	onClick={openPriceUpdateModalisTrue}>
																	Update Price
																</button>
																:
																""
														}
													</span>
												</div>
											</div>




											{/* <div className="row conv-pb10 conv-pt10">
												{/* <div className="col-4 conv-pr0">
													<span className="spled-colored-label">Offline Meet</span>
												</div> */}
											{/* <div className="col-8"> */}
											{
												<>
													{/* <div className="spm-notes-details"> */}
													{/* <label style={{float:"left",marginRight:"5px",marginLeft:"15px",marginTop:"5px"}}>
														 Offline Meet
														 </label> */}
													{/* <Select
															 //style={{innerWidth:"500px"}}
															 //placeholder="Select Need to talk to SP"
															 options={props.offlinemeetoptions}
															 onChange={props.setselectedofflinemeetoptions}
															 value={props.selectedofflinemeetoptions}
															  
														 ></Select> */}
													{/* </div> */}
													{/*<Button className="sp-inline-button"
														 onClick={props.onUpdateNeedToTalkToSPFlag}>
															 Save
														 </Button>*/}
													{/* <div style={{clear:"both"}}></div>		 */}
												</>

											}
											{/* </div> */}
											{/* </div> */}


											{/* <div className="row conv-pb10 conv-pt10">
												<div className="col-4 conv-pr0">
													<span className="spled-colored-label">Call Connected</span>
												</div>
												<div className="col-8">
													{
														// props.selectedServiceForEdit&&props.selectedServiceForEdit.nResourceInstanceId&&props.selectedServiceForEdit.nResourceInstanceId===row.original.nResourceInstanceId?				
														(
															<>	
																{
																	<Select
																		placeholder={"Select call status"}
																		options={props.offlinemeetoptions}
																		onChange={(e) =>props.onOfflineMeetOptionChange(e,row.original)}
																		//value={getSelectedItem(props.offlinemeetoptions,props.selectedServiceForEdit.custsCallStatus)}
																		className='react-select-container'
																		classNamePrefix="react-select"
																		theme={theme => ({
																			...theme,
																			colors: {
																			...theme.colors,
																			primary: '#76287C',
																			primary25: '#F4DFF4',
																			},
																		})}
																		// isDisabled={row.original.custrefSRState=="Cancelled"||row.original.custrefSRState=="Delivered"}
																	></Select>
																}
															</>							
														)
														(
															<span className="spled-black-text">{getSelectedItemLable(props.callStatusOptions,row.original.sCallStatus)||""}</span>
														)
													}
													
												</div>
											</div> */}

											{

												row.original.sServiceCode === "UDYAMREG" || row.original.sServiceCode === "BOOKACCBALKEEP" || row.original.sServiceCode === "PARTSHIPDEED" || row.original.sServiceCode === "ITR" || row.original.sServiceCode === "GSTREG"
													|| row.original.sServiceCode === "GSTRETURNFILING" || row.original.sServiceCode === "OPCFORM" || row.original.sServiceCode === "PVTLTDCOMP" || row.original.sServiceCode === "LVLICENSEAGRREG" || row.original.sServiceCode === "TRADMRK"
													|| row.original.sServiceCode === "COPYRIGHT" || row.original.sServiceCode === "SHOPACT" || row.original.sServiceCode === "FSSAI" || row.original.sServiceCode === "FSSAILICENSE" || row.original.sServiceCode === "LLPFORM"
													|| row.original.sServiceCode === "LLPROCCOMPAMC" ?
													(
														<div className="row conv-pb10 conv-pt10">
															<div className="col-4 conv-pr0">
																<span className="spled-colored-label">Offline Meet</span>
															</div>
															<div className="col-8">
																{

																	props.selectedServiceForEdit && props.selectedServiceForEdit.nResourceInstanceId && props.selectedServiceForEdit.nResourceInstanceId === row.original.nResourceInstanceId ?

																		(
																			<>
																				{
																					<Select
																						placeholder={"Select"}
																						options={props.offlinemeetoptions}
																						onChange={(e) => props.onOfflineMeetOptionChange(e, row.original)}
																						value={getSelectedItem(props.offlinemeetoptions, props.selectedServiceForEdit.custbOfflineMeet)}
																						className='react-select-container'
																						classNamePrefix="react-select"
																						theme={theme => ({
																							...theme,
																							colors: {
																								...theme.colors,
																								primary: '#76287C',
																								primary25: '#F4DFF4',
																							},
																						})}
																						isDisabled={row.original.custrefSRState == "Cancelled" || row.original.custrefSRState == "Delivered"}
																					></Select>
																				}
																			</>
																		) :
																		(
																			<span className="spled-black-text">{getSelectedItemLable(props.offlinemeetoptions, row.original.bOfflineMeet) || ""}</span>
																		)
																}

															</div>
														</div>
													)
													:
													("")
											}






											{
												props.selectedServiceForEdit && props.selectedServiceForEdit.custsSRCancellationReason && props.selectedServiceForEdit.custsSRCancellationReason === "Other" ?
													(
														<div className="row conv-pb10">
															<div className="col-12">
																<textarea
																	className={`w-100 form-control rounded`}
																	placeholder="Please specify a reason here"
																	style={{ minHeight: "60px", maxHeight: "60px" }}
																	name="custssSRCancellationReasonOtherDescription"
																	autoComplete="off"
																	value={props.selectedServiceForEdit.custssSRCancellationReasonOtherDescription}
																	onChange={(e) => {
																		props.handleServiceRequestsNotesChange(e.target.name, e.target.value);
																	}}
																	disabled={row.original.custrefSRState == "Cancelled" || row.original.custrefSRState == "Delivered"}
																/>
															</div>
														</div>
													) :
													(
														""
													)
											}
										</div>
										<div className="col-5">
											<div className="row conv-pb10 conv-pt5 conv-pr10">
												<div className="col-9 conv-pl5 conv-pr5">
													<span className="spled-colored-label conv-float-left">Notes</span>
													<span
														className="spled-colored-label conv-float-right conv-text-decoration-u conv-ml10 con-cursor-pointer"
														onClick={(e) => { handleViewAllNotes(row.original) }}
													>View All Notes</span>
												</div>
												<div className="col-3">
													<span
														className="spled-colored-label conv-float-right conv-text-decoration-u con-cursor-pointer"
														onClick={(e) => { handleViewNotesTrail(row.original) }}
													>Trail</span>
												</div>
											</div>
											<div className="row conv-pb10">
												<div className="col-12 conv-pl5 conv-pr15">
													{
														props.selectedServiceForEdit && props.selectedServiceForEdit.nResourceInstanceId && props.selectedServiceForEdit.nResourceInstanceId === row.original.nResourceInstanceId ?
															(
																<textarea
																	key={props.selectedServiceForEdit.nResourceInstanceId}
																	className="w-100 form-control rounded conv-mr15"
																	name="custsNotesHH"
																	value={props.selectedServiceForEdit.custsNotesHH || ""}
																	style={{ minHeight: "90px", maxHeight: "90px" }}
																	autoFocus={props.activeFocus === "custsNotesHH"}
																	//placeholder="Notes"
																	onChange={(e) => {
																		props.handleServiceRequestsNotesChange(e.target.name, e.target.value);
																	}}
																/>
															) :
															(
																<textarea
																	className="w-100 form-control rounded conv-mr15"
																	name="custsNotesHH"
																	style={{ minHeight: "90px", maxHeight: "90px" }}
																	disabled={true}
																/>
															)
													}
													{
														props.isFollowUpOpen && (
															<div className="div-Float-follow-up w-100">
																<div className="row">
																	<div className="col-md-12">
																		<div className="conv-mb25">
																			<span class="spled-info-title">Add Follow Up</span>
																			<button onhou className="outbound-close" onClick={props.handleFollowUpClick}>
																				<X />
																			</button>
																		</div>

																		<ReactDatePicker
																			dateFormat="dd/MM/yyyy"
																			selected={props.FollowUpDate}
																			onChange={(date) => props.setFollowUpDate(date)}
																			placeholderText="Follow Up on"
																			minDate={new Date()}
																		/>

																		<div className="conv-pb10 conv-mt20">
																			<div className="col-12 conv-pr0 conv-mt10 conv-pl10  spled-grid-checkbox">
																				<Checkbox
																					id={`checkbox-completed`}
																					checked={props.isFollowUpCompleted || false}
																					onChange={(e) => {
																						e.stopPropagation();
																						props.setisFollowUpCompleted(!props.isFollowUpCompleted);
																					}}
																					label={"Mark Completed"}
																					disabled={props.FollowUpDate ? false : true}
																				></Checkbox>
																			</div>
																		</div>

																		<button
																			type="button"
																			className="con-btn-filled conv-float-right conv-mt20"
																			onClick={(e) => props.onFollowUpSave(e, row.original)}>
																			Save
																		</button>
																	</div>
																</div>
															</div>
														)}
												</div>
											</div>
											{
												row.original.nPackageInstanceId ?
													(
														<div className="row conv-pb10">
															<div className="col-12 conv-pr0 conv-pl5 spled-grid-checkbox">
																<Checkbox
																	id={`checkbox-handled`}
																	checked={props.selectedServiceForEdit && props.selectedServiceForEdit.custsUpdateNoteForAllServicesInPackage || false}
																	onChange={(e) => {
																		e.stopPropagation();
																		props.handleServiceRequestsNotesChange(
																			"custsUpdateNoteForAllServicesInPackage", !(props.selectedServiceForEdit && props.selectedServiceForEdit.custsUpdateNoteForAllServicesInPackage)
																		);
																	}}
																	label={"Save for all Package service"}
																	disabled={!(props.selectedServiceForEdit && props.selectedServiceForEdit.nResourceInstanceId && props.selectedServiceForEdit.nResourceInstanceId === row.original.nResourceInstanceId)}
																></Checkbox>
															</div>
														</div>
													) : ("")
											}

											<div className="row conv-pb10">
												<div className="col-3 conv-pr0 conv-pl5">
													{
														row.original.custrefSRState != "Cancelled" && row.original.custrefSRState != "Delivered" && row.original.custrefSRState != "Payment Received" && !props.isForAdmin ?
															(
																(row.original.custrefSRState === "Partial/ Full Payment Pending" && row.original.user_sms_count.willing_count < row.original.user_sms_count.willing_count_limit) ?
																	(
																		<button type="button"
																			className="con-btn-bordered"
																			onClick={(e) => {
																				props.handleSendSMSClick(row.original);
																			}}
																		>Send SMS</button>
																	) :
																	row.original.custrefSRState != "Partial/ Full Payment Pending" && row.original.user_sms_count.not_willing_count < row.original.user_sms_count.not_willing_count_limit ?
																		(
																			<button type="button"
																				className="con-btn-bordered"
																				onClick={(e) => {
																					props.handleSendSMSClick(row.original);
																				}}
																			>Send SMS</button>
																		) :
																		(
																			<button type="button"
																				className="con-btn-bordered"
																				style={{ cursor: "not-allowed" }}
																				title={"SMS limit for this service request has been reached"}
																			>Send SMS</button>
																		)
															) :
															(
																<button type="button"
																	className="con-btn-bordered"
																	style={{ cursor: "not-allowed" }}
																>Send SMS</button>
															)
													}
												</div>
												<div className="col-4 conv-pl5">
													{
														row.original.sPaymentReceiver === "deAsra"
															?
															row.original.custrefSRState === "Full Payment Requested" && row.original.sPaymentMode === "2_Step_Payment"
																?
																<button type="button"
																	className="con-btn-bordered"
																	onClick={resendPaymentLinkSPM}
																	title="Resend Payment Link"
																>Resend Link</button>
																:
																row.original.custrefSRState === "Prepared" || row.original.custrefSRState === "Partial/ Full Payment Pending"
																	?
																	<button type="button"
																		className="con-btn-bordered"
																		onClick={resendPaymentLink}
																		title="Resend Payment Link"
																	>Resend Link</button>
																	:
																	""
															:
															""
													}
												</div>
												<div className="offset-1 col-2 conv-pl15 conv-pr15">
													{!props.isForAdmin ?
														(
															<span
																className="spled-colored-label conv-text-decoration-u conv-float-right con-cursor-pointer"
																onClick={props.handleFollowUpClick}
															>Follow Up
															</span>
														)
														:
														(
															<span
																className="spled-colored-label conv-text-decoration-u conv-float-right con-cursor-pointer"
																style={{ cursor: "not-allowed" }}
															>Follow Up
															</span>
														)
													}

												</div>
												<div className="col-2 conv-pr15">
													<span
														className="spled-colored-label conv-text-decoration-u conv-float-right con-cursor-pointer"
														onClick={(e) => { handleViewSMSTrail(row.original) }}
													>SMS Trail</span>
												</div>
											</div>

											{/* {
												(row.original.sServiceCode === "MKTLINKAGEBULKBUYER" || row.original.sServiceCode === "MKTLINKAGEECOM" || row.original.sServiceCode === "MKTLINKAGECORPLINKAGE" ||
													row.original.sServiceCode === "MKTLINKAGESHOPINSHOP" || row.original.sServiceCode === "MKTLINKAGEEXHIBITION" || row.original.sServiceCode === "MKTLINKAGEEXPORT") &&
												<div className="conv-pb10">
													<div className="row col-12 conv-pr0 conv-mt10 conv-pl0 spled-grid-checkbox1">
														<Checkbox
															id={`checkbox1-completed`}
															checked={row.original.bConfirmation_tag}
															onChange={(e) => {
																e.stopPropagation();
																// setConfirmationChecked(!confirmationChecked)
																updateConfirmationFlagData(row.original)
																// props.getExternalPartnerServices()
															}}
															label={"Confirmation Received"}
															disabled={row.original.bConfirmation_tag}
														></Checkbox>
															{
																row?.original?.bConfirmation_tag ? (
																	<>
																		{row.original.bConfirmation_tag && (
																			<span className="lpm-service-grid-value conv-mr10" style={{ wordBreak: "break-all" }}>
																				<img src={rightIcon} alt="Checked Icon" width={28} height={28} />
																			</span>
																		)}
																		<span>Confirmation Received</span>
																	</>

																) : (
																	<div className="col-12 conv-zindex" style={{paddingLeft: '3px'}}>
																		<Select
																			options={confCodeEligibleOptions}
																			onChange={(option) => confCodeEligibleOptionChange(option, row.original)}
																			value={selectedConfCode}
																			placeholder="Confirmation Recd."
																			isClearable
																		/>
																	</div>
																)
															}
													</div>
												</div>
											} */}


											<div className="row conv-pb10">
												{/* <div className="col-4 pl0">
													{
														row.original.sPaymentReceiver === "deAsra"
															?
															row.original.custrefSRState === "Full Payment Requested" && row.original.sPaymentMode === "2_Step_Payment"
																?
																<button type="button"
																	className="con-btn-bordered"
																	onClick={resendPaymentLinkSPM}
																>Send Payment Link</button>
																:
																row.original.custrefSRState === "Prepared"
																	?
																	<button type="button"
																		className="con-btn-bordered"
																		onClick={resendPaymentLink}
																	>Send Payment Link</button>
																	:
																	""
															:
															""
													}
												</div> */}
												<div className="col-12 conv-pr0">
													{
														props.selectedServiceForEdit && props.selectedServiceForEdit.nResourceInstanceId && props.selectedServiceForEdit.nResourceInstanceId === row.original.nResourceInstanceId ?
															(
																<>
																	<button
																		type="button"
																		className="con-btn-filled conv-float-right conv-mr15"
																		onClick={(e) => {

																			props.onRowSave(e, row.original)
																		}
																		}>
																		Save
																	</button>

																	<button
																		type="button"
																		className="con-btn-bordered-lg conv-float-right conv-mr15"
																		onClick={(e) => props.onRowCancelEdit(e, row.original)}>
																		Clear
																	</button>
																</>
															) :
															(
																<>
																	{row.original.custrefSRState == "Cancelled" || props.isForAdmin/*||row.original.custrefSRState=="Delivered"*/ ?
																		(
																			<button
																				type="button"
																				className="con-btn-filled conv-float-right conv-mr15 conv-mt5"
																				disabled>
																				Edit
																			</button>
																		) :
																		(
																			<button
																				type="button"
																				className="con-btn-filled conv-float-right conv-mr15 conv-mt5"
																				onClick={(e) => props.onRowDoubleClick(e, row.original)}>
																				Edit
																			</button>
																		)}
																</>
															)
														// <>	
														// 	<button 
														// 		type="button" 
														// 		className="con-btn-filled conv-float-right conv-mr15"
														// 		onClick={(e) =>props.onRowSave(e,row.original)}>
														// 		Save
														// 	</button>

														// 	<button 
														// 		type="button" 
														// 		className="con-btn-bordered-lg conv-float-right conv-mr15"
														// 		onClick={(e) =>props.onRowCancelEdit(e,row.original)}>
														// 		Clear
														// 	</button>


														// 		{/* <button 
														// 			type="button" 
														// 			className="con-btn-filled conv-float-right conv-mr15 conv-mt5"
														// 			disabled>
														// 			Edit
														// 		</button> */}


														// 			<button 
														// 			type="button" 
														// 			className="con-btn-filled conv-float-right conv-mr15 conv-mt5"
														// 			onClick={(e) =>props.onRowDoubleClick(e,row.original)}>
														// 			Edit
														// 		</button>
														// </>		


													}

												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						);
					}}
					/*onPageChange={pageIndex => {
						props.changePage(pageIndex)
						reactTable.current.props.onFetchData();
					}}*/
					// PaginationComponent={Pagination}
					PaginationComponent={(paginationProps) => (
                        <Pagination
                            {...paginationProps}
                            displayRecordCount={props?.displayRecordCount}
                    />
                    )}
					style={{ overflowY: "initial", height: "500px" }}
					NextComponent={(instance) => (
						<Button className="mt3" {...instance}>
							Next
						</Button>
					)}
					PreviousComponent={(instance) => (
						<Button className="mt3" {...instance}>
							Previous
						</Button>
					)}
					className="-striped"
				/>/*):""*/}
			</div>
			{
				showViewAllNotesModal &&
				(
					<ESPViewAllNotesModal
						isOpen={showViewAllNotesModal}
						toggleModal={toggleViewAllNotesModal}
						sEmailAddress={selectedCustomerEmailId}
						serviceNameListESP={props.serviceNameListForFilter}
					/*selectedSPLedService={selectedSPLedService}
					onAddNoteClicked={(e) =>{
						props.onRowDoubleClick(e,selectedSPLedService);
						toggleViewAllNotesModal();
					}}*/
					>
					</ESPViewAllNotesModal>
				)
			}
			{
				showNotesTrailModal &&
				(
					<ESPNotesTrailModal
						isOpen={showNotesTrailModal}
						toggleModal={toggleNotesTrailModal}
						nResourceInstanceId={selectednResourceInstanceID}
					>
					</ESPNotesTrailModal>
				)
			}
			{
				showSMSTrailModal &&
				(
					<ESPSMSTrailModal
						isOpen={showSMSTrailModal}
						toggleModal={toggleSMSTrailModal}
						nResourceInstanceId={selectednResourceInstanceID}
					>
					</ESPSMSTrailModal>
				)
			}
			{
				props.showFilterModal &&
				(
					<SPLedFilterModel
						isOpen={props.showFilterModal}
						toggleModal={props.toggleFilterModal}
						toggleAllForFilter={props.toggleAllForFilter}
						toggleSelectionForFilter={props.toggleSelectionForFilter}
						serviceNameListForFilter={props.serviceNameListForFilter}
						selectedServiceNameListForFilter={props.selectedServiceNameListForFilter}
						fromDate={props.fromDate}
						setfromDate={props.setfromDate}
						toDate={props.toDate}
						settoDate={props.settoDate}
						requestedByOptions={props.requestedByOptions}
						setSelectedRequestedByOption={props.setSelectedRequestedByOption}
						selectedRequestedByOption={props.selectedRequestedByOption}
						packageNameListForFilter={props.packageNameListForFilter}
						oppTypeNameListforFilter={props.oppTypeNameListforFilter}
						setSelectedPackageNameListForFilter={props.setSelectedPackageNameListForFilter}
						selectedPackageNameListForFilter={props.selectedPackageNameListForFilter}
						requestedaCallBackOptions={props.requestedaCallBackOptions}
						setSelectedNeedToTalkToSPOption={props.setSelectedNeedToTalkToSPOption}
						selectedNeedToTalkToSPOption={props.selectedNeedToTalkToSPOption}
						toggleServiceStatus={props.toggleServiceStatus}
						serviceStatusList={props.serviceStatusList}
						callStatusOptionsForFilter={props.callStatusOptionsForFilter}
						setselectedCallStatusOptionForFilter={props.setselectedCallStatusOptionForFilter}
						selectedCallStatusOptionForFilter={props.selectedCallStatusOptionForFilter}
						setSelectedRequestedaCallBackOption={props.setSelectedRequestedaCallBackOption}
						selectedRequestedaCallBackOption={props.selectedRequestedaCallBackOption}
						onSearchClicked={props.onSearchClicked}
						onClearFilterSearch={props.onClearFilterSearch}
						toggleAllForServiceStatusFilter={props.toggleAllForServiceStatusFilter}
						toggleSelectionForServiceStatusFilter={props.toggleSelectionForServiceStatusFilter}
						selectedServiceStatusListForFilter={props.selectedServiceStatusListForFilter}
						serviceStatusNameListForFilter={props.serviceStatusNameListForFilter}

						//offline meet
						offlinemeetoptionsForFilter={props.offlinemeetoptionsForFilter}
						setselectedofflinemeetoptionsForFilter={props.setselectedofflinemeetoptionsForFilter}
						selectedofflinemeetoptionsForFilter={props.selectedofflinemeetoptionsForFilter}



						// offlinemeetoptions={props.offlinemeetoptions}
						// selectedofflinemeetoptions={props.selectedofflinemeetoptions}
						// setselectedofflinemeetoptions={props.setselectedofflinemeetoptions}




						//for admin
						externalServicePartnerOptions={props.externalServicePartnerOptions}
						selectedExternalServicePartner={props.selectedExternalServicePartner}
						onExternalServicePartnerChange={props.onExternalServicePartnerChange}
						ExternalServicePartnerOrganization={props.ExternalServicePartnerOrganization}
						isForAdmin={props.isForAdmin}
					>
					</SPLedFilterModel>
				)
			}
			{
				showViewAllSMSModal &&
				(
					<CentralizedSMSLogModal
						isOpen={showViewAllSMSModal}
						toggleModal={toggleViewAllSMSModal}
						sEmailAddress={selectedCustomerEmailId}
						serviceNameListESP={props.serviceNameListForFilter}
					/*selectedSPLedService={selectedSPLedService}
					onAddNoteClicked={(e) =>{
						props.onRowDoubleClick(e,selectedSPLedService);
						toggleViewAllNotesModal();
					}}*/
					>
					</CentralizedSMSLogModal>
				)
			}
			{
				props.showdePreneurDetailsModal &&
				(
					<DePreneurListingModal
						isOpen={props.showdePreneurDetailsModal}
						toggleModal={props.handleViewdePreneurDetailsModal}
						selectedServiceRequestBusinessDetails={props.selectedServiceRequestBusinessDetails}
						selectedServiceRequestBusinessDetailsForEdit={props.selectedServiceRequestBusinessDetailsForEdit}
						onBusinessDetailsChange={props.onBusinessDetailsChange}
						onBusinessDetailsUpdate={props.onBusinessDetailsUpdate}
						onBusinessVerifyUpdate={props.onBusinessVerifyUpdate}
						ondePreneurDetailsUpdate={props.ondePreneurDetailsUpdate}
						isForAdmin={props.isForAdmin}
					>
					</DePreneurListingModal>
				)
			}

			<Modal isOpen={openViewProductModel}>
				<ModalContent className="product-list-table">
					<div className="modal-header" style={{
						backgroundColor: '#76287C',
						color: '#fff'
					}}>
						<span className="modal-title">Product Details </span>
						<img
							alt="close"
							id="Close"
							src={close_modal}
							className="close modal-close"
							onClick={handleCloseProductListMoal}
						/>
					</div>

					<div className="modal-body">
						<div className={`${TagModalLoading && "set-opacity"}`}>
							{/* TABLE COMPONENT */}
							<div>
								{
									productLists.length > 0 ?
										<div className="" style={{
											height: "300px",
											margin: "10px 10px"
										}}>
											<div style={{ height: "100%", boxSizing: "border-box" }}>
												<div style={gridStyle} className="ag-theme-material">
													<AgGridReact
														ref={gridRef}
														rowData={productLists || []}
														columnDefs={productListColumnDefs}
													>
													</AgGridReact>
												</div>
											</div>
										</div>
										:
										<div className="spled-colored-label">
											No Data Found
										</div>
								}
							</div>
						</div>
					</div>
				</ModalContent>
			</Modal>
		</div>

	);
}